import React from 'react';
import 'moment-timezone';
import rolesAccount from './roles';
import { momentInstance } from 'helpers/date-time';

export const MONTH_NEED_RESET_PASSWORD = 3;
export const DEFAULT_PAGE_SIZE = 100;
export const SIZE_ICON_NODE = 18;
export const INTERVAL_TIME = 2000;

export const evaluatedElementsEnum = {
  CREATIVE: 'CREATIVE',
  MEDIA: 'MEDIA',
  OFFER: 'OFFER',
  ROUTE: 'ROUTE',
  ANI: 'ANI',
  'DID GROUP': 'DID_GROUP',
};

export const optionsEvaluatedElements = Object.entries(evaluatedElementsEnum).map(
  ([label, value]) => ({ label, value }),
);

export const AOStatOptions = [
  {
    label: 'ROI',
    value: 'ROI',
  },
  {
    label: 'Profit',
    value: 'PROFIT',
  },
  {
    label: 'Revenue',
    value: 'REVENUE',
  },
  {
    label: 'Conversion Rate',
    value: 'CONVERSION_RATE',
  },
  {
    label: 'Reply Rate',
    value: 'REPLY_RATE',
  },
  {
    label: 'Click Rate',
    value: 'CLICK_RATE',
  },
  {
    label: 'Delivery Rate',
    value: 'DELIVERY_RATE',
  },
  {
    label: 'Rev/mil',
    value: 'REV_MIL',
  },
];

export const AOOperatorOptions = [
  {
    label: 'Less Than',
    value: 'LT',
  },
  {
    label: 'Equal',
    value: 'EQ',
  },
  {
    label: 'Greater Than',
    value: 'GT',
  },
];

export const tabOfSettings = {
  profile: 'profile',
  integrations: 'integrations',
  accountInfo: 'account-info',
  notifications: 'notifications',
  advancedSettings: 'advanced-settings',
  clickRequest: 'click-request',
  api: 'api',
  payment: 'payment',
  priceTable: 'price-table',
  orderServices: 'order-service',
  routesInfo: 'routes-info',
  voluum: 'voluum',
  security: 'security',
  kyc: 'kyc',
  subscriptionPlan: 'subscription-plan',
  trackingTab: 'tracking',
};

export const contactField = {
  gender: 'gender',
  carrier: 'carrier',
  engagement: 'engagement',
  creation_date: 'creation_date',
  phoneType: 'phoneType',
  dob: 'dob',
  children_birthday: 'children_birthday',
  externalCertingId: 'externalCertingId',
  certingDate: 'certingDate',
  os: 'os',
};

export const GenderEnums = (asNumber) => {
  if (asNumber) {
    return {
      male: 1,
      female: 0,
    };
  }

  return {
    male: 'male',
    female: 'female',
  };
};

export const ContinentEnums = ['Asia', 'Africa', 'Oceania', 'South America', 'North America'];

export const AgeOfVoiceEnums = {
  Young: 'young',
  'Middle Age': 'middle_aged',
  Old: 'old',
  Other: 'other',
};

//* TA-13237: [Route Price Table] Outbound call and outbound call cost service dislay is a bit confusing
export const ServiceTypeHaveSpecialCost = ['OUTBOUND_VB_CALL_COST', 'INCOMING_CALL_COST'];

export const customDateOption = {
  label: 'Custom range',
  value: 'customRange',
};

export const DateOptionEnum = {
  thirtyMin: 'thirtyMin',
  oneHour: 'oneHour',
  today: 'today',
  yesterday: 'yesterday',
  thisWeek: 'thisWeek',
  lastWeek: 'lastWeek',
  last1Days: 'last1Days',
  last7Days: 'last7Days',
  last30Days: 'last30Days',
  thisMonth: 'thisMonth',
  lastMonth: 'lastMonth',
  thisYear: 'thisYear',
};

export const optionsPresets = [
  {
    label: '30 Min',
    value: DateOptionEnum.thirtyMin,
  },
  {
    label: '1 Hour',
    value: DateOptionEnum.oneHour,
  },
  {
    label: 'Today',
    value: DateOptionEnum.today,
  },
  {
    label: 'Yesterday',
    value: DateOptionEnum.yesterday,
  },
  {
    label: 'This week',
    value: DateOptionEnum.thisWeek,
  },
  {
    label: 'Last week',
    value: DateOptionEnum.lastWeek,
  },
  {
    label: 'Last 7 Days',
    value: DateOptionEnum.last7Days,
  },
  {
    label: 'Last 30 Days',
    value: DateOptionEnum.last30Days,
  },
  {
    label: 'This month',
    value: DateOptionEnum.thisMonth,
  },
  {
    label: 'Last month',
    value: DateOptionEnum.lastMonth,
  },
  {
    label: 'This year',
    value: DateOptionEnum.thisYear,
  },
  customDateOption,
];

export const OperatorEnum = {
  equal: 'EQUAL',
  inEqual: 'INEQUAL',
  greater: 'GREATER',
  lesser: 'LESSER',
  between: 'BETWEEN',
  contains: 'CONTAINS',
  exists: 'EXISTS',
  notExists: 'NOT_EXISTS',
};

export const BooleanOperatorEnum = {
  and: 'AND',
  or: 'OR',
};

export const StatusAudioSpintaxApprovalEnum = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
};

export const StatusChangeRequestEnum = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  RELEASED: 'RELEASED',
  FAILED: 'FAILED',
};

export const StatusServicesEnum = {
  RUNNING: 'RUNNING',
  IN_MAINTENANCE: 'IN_MAINTENANCE',
};

export const SanitizingTypeEnum = {
  sanitizingMessageUnicodeEnabled: 'sanitizingMessageUnicodeEnabled',
  sanitizingTagUnicodeEnabled: 'sanitizingTagUnicodeEnabled',
};

export const SanitizingOptions = [
  { label: 'Entire message', value: SanitizingTypeEnum.sanitizingMessageUnicodeEnabled },
  { label: 'Tag only', value: SanitizingTypeEnum.sanitizingTagUnicodeEnabled },
];

export const TrackingVendorsEnum = {
  Voluum: 'voluum',
  Trackdrive: 'trackdrive',
};

export const VolummType = {
  MessageID: 'msgID',
  PhoneMapping: 'phoneMapping',
};

export const FinanceFamilyGroup = [
  'SEND_SMS',
  'LANDLINE_CHECK',
  'PURCHASE_NUMBER',
  'INBOUND_SMS',
  'SEND_EMAIL_NOTIFICATION',
  'INCOMING_CALL',
  'RESPONDER_SEND_SMS',
  'DNC_CHECK',
  'CARRIER_LOOKUP',
  'OUTBOUND_VB_CALL',
  'SHORT_DOMAIN',
  'CALLER_ID_LOOKUP',
  'SURCHARGE_VERIZON',
  'SURCHARGE_ATT',
  'SURCHARGE_US_CELL',
  'SURCHARGE_T_MOBILE',
  'SURCHARGE_SPRINT',
  'FAILOVER_SEND_SMS',
  'INBOUND_SMS_T_MOBILE',
  'SEND_MMS',
  'RESPONDER_SEND_MMS',
  'PREMIUM_SERVICE',
  'SURCHARGE_MMS_BELL_VIRGINFREE',
  'SURCHARGE_MMS_FREEDOM_MOBILE',
  'SURCHARGE_MMS_FIDO_FREE',
  'SURCHARGE_MMS_ROGERS_FREE',
  'SURCHARGE_MMS_TELUS_FREE',
  'SURCHARGE_MMS_VIDEOTRON_FREE',
  'BRAND_REGISTRATION',
  'CAMPAIGN_MAINTAIN',
  'T_MOBILE_DID_LINKING',
  'CONTACT_CHECK',
  'SURCHARGE_C_SPIRE',
  'SURCHARGE_METRO_PCS',
  'INBOUND_SMS_METRO_PCS',
  'INBOUND_SMS_Sprint',
  'SURCHARGE_LLEIDA',
  'SURCHARGE_CRICKET',
  'SURCHARGE_BLUEGRASS_CELLULAR',
  'SURCHARGE_COMMNET_WIRELESS',
  'SURCHARGE_TEXTNOW',
  'DID_MAINTAIN',
  'CREDIT_CARD_PROCESSING',
  'SURCHARGE_SASKTEL',
  'BRAND_VETTING',
  'CAMPAIGN_REGISTRATION',
  'INVOICE_PROCESSING',
  'SEND_MMSE',
  'SURCHARGE_CELLULAR_SOUTH',
  'PURCHASE_INIT_CAMPAIGN_NUMBER',
  'SURCHARGE_EASTLINK',
  'INBOUND_SMS_US_CELL',
  'SURCHARGE_PUERTO_RICO_CLARO',
  'TOLL_FREE_DID_SETUP',
  'INBOUND_VB_CALL',
  'RINGLESS_VOICE_MAIL',
  'CREATIVE_ASSISTANT',
  'RINGLESS_VOICE_MAIL_CAMPAIGN_REGISTRATION',
  'AUDIO_BUILDER_ASSISTANT',
  'PURCHASE_TOLL_FREE_NUMBER',
  'ANSWER_MACHINE_DETECTION',
  'USER_SUBSCRIPTION',
  'SURCHARGE_ATT_MMS',
  'SURCHARGE_OTHERS',
  'API_PACKAGE',
  'CONTACT_CERTING',
  'INBOUND_MMS',
  'SURCHARGE_T_MOBILE_MMS',
  'SURCHARGE_VERIZON_MMS',
  'SURCHARGE_US_CELLULAR_MMS',
  'SURCHARGE_METRO_PCS_MMS',
  'SURCHARGE_C_SPIRE_MMS',
  'SURCHARGE_CRICKET_MMS',
  'SURCHARGE_BLUEGRASS_CELLULAR_MMS',
  'SURCHARGE_COMMNET_WIRELESS_MMS',
  'SURCHARGE_TEXTNOW_MMS',
  'SURCHARGE_SASKTEL_MMS',
  'SURCHARGE_CELLULAR_SOUTH_MMS',
  'SURCHARGE_PUERTO_RICO_CLARO_MMS',
  'SURCHARGE_OTHERS_MMS',
  'INBOUND_MMS_T_MOBILE',
  'INBOUND_MMS_METRO_PCS',
  'INBOUND_MMS_Sprint',
  'INBOUND_MMS_US_CELL',
  'MARKETPLACE_PURCHASE',
  'CONTACT_CHECK_INTERNATIONAL',
  'DID_RELEASE',
  'CONTACT_DATA_STORAGE',
  // 'OUTBOUND_VB_CALL_COST',
  // 'INCOMING_CALL_COST',
  'DID_SCRUBBING',
  'AI_ASSISTANT',
  'CONTACT_HEADER_ASSISTANT',
];

export const ModeUsernameEnum = {
  EXCLUDE: 'EXCLUDE',
  INCLUDE: 'INCLUDE',
};

export const FilterTargetTypeEnum = {
  INCLUDE: 'INCLUDE',
  EXCLUDE: 'EXCLUDE',
};

export const TestingEnum = {
  DestinationType: {
    TESTELIUM: 'TESTELIUM',
    DEVICE: 'DEVICE',
    PHONE: 'PHONE',
  },
  SourceType: {
    ANI: 'ANI',
    DID: 'DID',
  },
};

export const TypeChartTenWeekEnum = {
  SMS_MMS: 'SMS_MMS',
  VOICE: 'VOICE',
  OTHER: 'OTHER',
  TOTAL: 'TOTAL',
};

export const StatusMigrationDIDEnum = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  RELEASING: 'RELEASING',
  RELEASED: 'RELEASED',
  // ROLLING_BACK: 'ROLLING_BACK',
  // ROLLBACK: 'ROLLBACK',
};

export const MonthsEnum = [
  {
    value: 1,
    abbreviation: 'Jan',
    name: 'January',
  },
  {
    value: 2,
    abbreviation: 'Feb',
    name: 'February',
  },
  {
    value: 3,
    abbreviation: 'Mar',
    name: 'March',
  },
  {
    value: 4,
    abbreviation: 'Apr',
    name: 'April',
  },
  {
    value: 5,
    abbreviation: 'May',
    name: 'May',
  },
  {
    value: 6,
    abbreviation: 'Jun',
    name: 'June',
  },
  {
    value: 7,
    abbreviation: 'Jul',
    name: 'July',
  },
  {
    value: 8,
    abbreviation: 'Aug',
    name: 'August',
  },
  {
    value: 9,
    abbreviation: 'Sep',
    name: 'September',
  },
  {
    value: 10,
    abbreviation: 'Oct',
    name: 'October',
  },
  {
    value: 11,
    abbreviation: 'Nov',
    name: 'November',
  },
  {
    value: 12,
    abbreviation: 'Dec',
    name: 'December',
  },
];

export const nodeTypeSettings = {
  action: 'action',
  trigger: 'trigger',
};

export const nodeTriggerTypes = {
  clickOnShortLink: 'click_link',
  inboundMessage: 'inbound_message',
  dtmf: 'dtmf',
  listenCall: 'listen_call',
  answeredCall: 'answered_call',
  forwardCall: 'forward_call',
  inboundCall: 'inbound_call',
  liveFeed: 'live_feed',
  noAnswer: 'no_answer',
};

export const nodeActionTypes = {
  sendMessage: 'send_message',
  fireRequest: 'fire_request',
  sendVoice: 'send_voice',
  playAudio: 'play_audio',
  forwardCall: 'forward_call',
};

export const MethodsFireRequest = {
  GET: 'GET',
  POST: 'POST',
};

export const TypeResponderOfferEnum = {
  onFly: 'inputText',
  selectOffer: 'selectOffer',
};

export const PopulateDataSettingEnum = {
  Delivered: 'delivered',
  Failed: 'failed',
  Replier: 'replier',
  Clicker: 'clicker',
  Convertor: 'convertor',
  Callback: 'callback',
  Listener: 'listener',
  Answered: 'answered',
  'DTMF pressed': 'dtmf_press',
  // 'IVR clicker': 'ivr_clicker',
};

export const RequestTypeCreditsEnum = {
  CREDIT_SET_MIN_BALANCE: 'CREDIT_SET_MIN_BALANCE',
  CREDIT_TRANSFER: 'CREDIT_TRANSFER',
};

export const OriginsInboxEnum = {
  CAMPAIGN: 'CAMPAIGN',
  API: 'API',
  RESPONDER: 'RESPONDER',
  MANUAL: 'MANUAL',
  AUTO_TEST: 'AUTO_TEST',
  AUTO_REPLY: 'AUTO_REPLY',
  INBOUND: 'INBOUND',
};

export const optionsDate = [
  {
    label: 'Today',
    value: DateOptionEnum.today,
  },
  {
    label: 'Yesterday',
    value: DateOptionEnum.yesterday,
  },
  {
    label: 'Last 1 Day',
    value: DateOptionEnum.last1Days,
  },
  {
    label: 'Last 7 Days',
    value: DateOptionEnum.last7Days,
  },
  {
    label: 'Last 30 Days',
    value: DateOptionEnum.last30Days,
  },
  {
    label: 'This month',
    value: DateOptionEnum.thisMonth,
  },
  {
    label: 'Last month',
    value: DateOptionEnum.lastMonth,
  },
];

export const WeekDays = {
  Monday: 2,
  Tuesday: 3,
  Wednesday: 4,
  Thursday: 5,
  Friday: 6,
  Saturday: 7,
  Sunday: 1,
};

export const UnitPeriodEnum = {
  DAYS: 'DAYS',
  MONTHS: 'MONTHS',
};

export const dateTimeDefault = () => {
  return {
    before7Days: momentInstance().subtract(7, 'days').startOf('date').toDate(),
    before3Days: momentInstance().subtract(3, 'days').startOf('date').toDate(),
    before30Days: momentInstance().subtract(30, 'days').startOf('date').toDate(),

    yesterday: momentInstance().subtract(1, 'days').startOf('date').toDate(),
    endYesterday: momentInstance().subtract(1, 'days').endOf('date').toDate(),

    startToDay: momentInstance().startOf('date').toDate(),
    today: momentInstance().endOf('date').toDate(),
    tomorrow: momentInstance().add(1, 'days').endOf('date').toDate(),

    next3Days: momentInstance().add(3, 'days').endOf('date').toDate(),
    next7Days: momentInstance().add(7, 'days').endOf('date').toDate(),

    startThisMonth: momentInstance().startOf('month').toDate(),
    endThisMonth: momentInstance().endOf('month').toDate(),

    startLastMonth: momentInstance().startOf('month').subtract(1, 'month').toDate(),
    endLastMonth: momentInstance().endOf('month').subtract(1, 'month').toDate(),
  };
};

export const MarketplaceEnum = {
  Type: {
    PRODUCT: 'PRODUCT',
    SERVICE: 'SERVICE',
  },
  DateCompare: {
    BEFORE: 'BEFORE',
    EQUAL: 'EQUAL',
    AFTER: 'AFTER',
  },
  Status: {
    'NEWLY CREATED': 0,
    PUBLISHED: 1,
    DELISTED: -1,
  },
};

export const RouteEnum = {
  Status: {
    ACTIVE: 'ACTIVE',
    DELETED: 'DELETED',
    SUSPENDED: 'SUSPENDED',
    DEACTIVATED: 'DEACTIVATED',
    PENDING: 'PENDING',
  },
};

export const CreditStatusEnum = {
  PENDING: 0,
  APPROVED: 1,
  RELEASED: 2,
  REJECTED: -1,
  'FAILED TO RELEASE': -2,
};

export const CreativeStatusEnum = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
};

export const MAX_INTERVAL = 50;
export const SIZE_ICON = 22;
export const URL_DEV = 'http://34.111.225.5';
export const OTP_LENGTH = 6;
export const LINK_REGEX = /(https?:\/\/[^\s]+)/g;
export const VALID_URL_REGEX = /^(ftp|http|https):\/\/[^ "]+$/;

export const TypeNumberPool = {
  TFN: 'TFN',
  DIGITAL_LONG_CODE: 'DIGITAL_LONG_CODE',
};

export const StatusProgramEnum = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};

export const Linked10dlcEnum = {
  COMPLETED: 'COMPLETED',
  PROCESSING: 'PROCESSING',
  FAILED: 'FAILED',
};

export const TollFreeEnum = {
  Statuses: {
    REQUESTING: 'REQUESTING',
    PROCESSING: 'PROCESSING',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
  },
  MessageVolume: [
    '10',
    '100',
    '1,000',
    '10,000',
    '100,000',
    '250,000',
    '500,000',
    '750,000',
    '1,000,000',
    '5,000,000',
    '10,000,000+',
  ],
};

export const StatusSIMEnum = {
  SCANNED: 'SCANNED',
  BAD: 'BAD',
  BURNED: 'BURNED',

  ACTIVATED: 'ACTIVATED',
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
  EXPIRED: 'EXPIRED',
  DELIVERING: 'DELIVERING',
  NOT_DELIVERING: 'NOT_DELIVERING',
};

export const ErrorTrackerEnum = {
  viewType: {
    // USER: 'USER',
    CAMPAIGN: 'CAMPAIGN',
    VENDOR: 'VENDOR',
    ROUTE: 'ROUTE',
    MNO_CARRIER: 'MNO_CARRIER',
  },
  granularity: {
    HOUR: 'HOUR',
    MINUTE: 'MINUTE',
  },
};

export const TypeCreditHistoryEnum = {
  CREDIT: 'CREDIT',
  STRIPE: 'STRIPE',
  BANK: 'BANK',
  REFUND: 'REFUND',
};

export const TypeStatsEnum = {
  bt2: 'bt2',
  rd: 'rd',
};

export const TypeStatsOptions = [
  {
    label: 'Route Detail',
    value: TypeStatsEnum.rd,
  },
  {
    label: 'BT2',
    value: TypeStatsEnum.bt2,
  },
];

export const CostTypeEnum = {
  perPlan: 'PER_PLAN',
  perMessage: 'PER_MESSAGE',
};

export const PlanTypeEnum = {
  fixedDuration: 'FIXED_DURATION',
  topUppable: 'TOP_UPPABLE',
};

export const typeFinanceReport = {
  customer: 'customer',
  vertical: 'vertical',
  product: 'product',
  finance: 'finance',
};

export const StatusSenderEnum = {
  Pending: -1,
  Disabled: 0,
  Enabled: 1,
};

export const optionsStatusSender = Object.entries(StatusSenderEnum).map(([label, value]) => {
  return {
    label,
    value,
  };
});

export const optionsTypeFinanceReport = [
  {
    label: 'Vertical',
    value: typeFinanceReport.vertical,
  },
  {
    label: 'Customer',
    value: typeFinanceReport.customer,
  },
  {
    label: 'Product',
    value: typeFinanceReport.product,
  },
  {
    label: 'Finance',
    value: typeFinanceReport.finance,
  },
];

export const statusKYCEnum = {
  '-1': '1 year lapsed',
  0: `NEW`,
  1: `PENDING REVIEW`,
  2: `PROCESSING`,
  9001: `Verified`,
  9102: `Not verified`,
  9103: `RESUBMISSION REQUIRED`,
  9104: `EXPIRED`,
  9121: `No conclusion has been made`,
};

export const optionsKYCStatus = [
  { label: 'All', value: '' },

  ...Object.entries(statusKYCEnum).map(([value, label]) => {
    return {
      label,
      value: Number(value),
    };
  }),
];

export const statusHistoryEnum = {
  running: 'running',
  scheduled: 'scheduled',
  completed: 'completed',
  paused: 'paused',
};

export const enumColumn = {
  title: 'title',
  contactGroup: 'contactGroup',

  // Grouped
  routes: 'routes',
  nameInRoute: 'nameInRoute',
  didGroupOrANI: 'didGroupOrANI',

  messageType: 'messageType',
  progress: 'progress',
  timeRemaining: 'timeRemaining',
  speed: 'speed',
  didInUsed: 'didInUsed',

  // Grouped
  statistic: 'statistic',
  total: 'total',
  campaignOffset: 'campaignOffset',
  sent: 'sent',
  delivered: 'delivered',
  clicked: 'clicked',
  replied: 'replied',
  failed: 'failed',
  optout: 'optout',
  blocked: 'blocked',
  attemptFailed: 'attemptFailed',
  convertor: 'convertor',

  mnoStatistic: 'mnoStatistic',

  // Grouped
  cost: 'cost',
  totalCost: 'totalCost',
  perClick: 'perClick',
  perMessage: 'perMessage',

  revenue: 'revenueCell',
  actions: 'actions',
  revenuePerMil: 'revenuePerMilCell',

  remainContact: 'remainContact',
  totalDid: 'totalDid',
};

export const sortDirection = {
  NO: '',
  ASC: 'ASC',
  DESC: 'DESC',
};

export const optionsTypeDownloadInvoice = [
  {
    label: 'PDF',
    value: 'pdf',
  },
  {
    label: 'XML',
    value: 'xml',
  },
];

export const TypeInvoiceEnum = {
  Invoice: 'invoice',
  PreInvoice: 'proformaInvoice',
  eInvoice: 'eInvoice',
  CreditInvoice: 'creditInvoice',
};

export const PayViaEnum = {
  CreditCard: 'credit',
  BankTransfer: 'bank',
  ReferralInvoice: 'referral',
};

export const StatusInvoiceEnum = {
  WaitPayment: 'WAIT_PAYMENT',
  Processing: 'PROCESSING',
  PartRelease: 'PART_RELEASE',
  Succeeded: 'SUCCEEDED',
  Failed: 'FAILED',
  Open: 'OPEN',
  Paid: 'PAID',
};

export const optionsPayVia = [
  {
    label: 'Bank transfer',
    value: PayViaEnum.BankTransfer,
  },
  {
    label: 'Credit card',
    value: PayViaEnum.CreditCard,
  },
  {
    label: 'Referral Invoice',
    value: PayViaEnum.ReferralInvoice,
  },
];

export const optionsStatusInvoice = [
  {
    label: 'Wait payment',
    value: StatusInvoiceEnum.WaitPayment,
  },
  {
    label: 'Processing',
    value: StatusInvoiceEnum.Processing,
  },
  {
    label: 'Part release',
    value: StatusInvoiceEnum.PartRelease,
  },
  {
    label: 'Part release locked',
    value: StatusInvoiceEnum.PartReleaseLocked,
  },
  {
    label: 'Succeeded',
    value: StatusInvoiceEnum.Succeeded,
  },
  {
    label: 'Failed',
    value: StatusInvoiceEnum.Failed,
  },
];

export const optionsStatusInvoiceReferral = [
  {
    label: 'Open',
    value: StatusInvoiceEnum.Open,
  },
  {
    label: 'Paid',
    value: StatusInvoiceEnum.Paid,
  },
];

export const SortFinanceEnum = {
  Email: 'BYCLIENT',
  Route: 'BYROUTE',
};

export const StatusRouteEnum = {
  ACTIVE: 'ACTIVE',
  DEACTIVATED: 'DEACTIVATED',
  SUSPENDED: 'SUSPENDED',
  DELETED: 'DELETED',
  PENDING: 'PENDING',
};

export const DLCEnum = {
  status: {
    PROCESSING: 'PROCESSING',
    COMPLETED: 'COMPLETED',
    REQUESTING: 'REQUESTING',
    ACTIVE: 'ACTIVE',
    FAILED: 'FAILED',
    DEACTIVATED: 'DEACTIVATED',
  },
  StatusEnumOptions: ['COMPLETED', 'PROCESSING', 'REQUESTING', 'FAILED', 'EXPIRED'],
  AlternateBusinessTypeEnum: ['DUNS', 'LEI', 'GIIN', 'NONE'],
  BrandTypeEnum: ['STANDARD', 'STARTER'],
  CustomerTypeEnum: ['DIRECT', 'RESELLER'],
  VerticalEnum: [
    'PROFESSIONAL',
    'REAL_ESTATE',
    'HEALTHCARE',
    'HUMAN_RESOURCES',
    'ENERGY',
    'ENTERTAINMENT',
    'RETAIL',
    'TRANSPORTATION',
    'AGRICULTURE',
    'INSURANCE',
    'POSTAL',
    'EDUCATION',
    'HOSPITALITY',
    'FINANCIAL',
    'POLITICAL',
    'GAMBLING',
    'LEGAL',
    'CONSTRUCTION',
    'NGO',
    'MANUFACTURING',
    'GOVERNMENT',
    'TECHNOLOGY',
    'COMMUNICATION',
  ],
  SubUsecaseTypeEnum: [
    '2FA',
    'ACCOUNT_NOTIFICATION',
    'CUSTOMER_CARE',
    'DELIVERY_NOTIFICATION',
    'FRAUD_ALERT',
    'HIGHER_EDUCATION',
    'MARKETING',
    'POLLING_VOTING',
    'PUBLIC_SERVICE_ANNOUNCEMENT',
    'SECURITY_ALERT',
  ],
  UsecaseTypeEnum: [
    '2FA',
    'ACCOUNT_NOTIFICATION',
    'CUSTOMER_CARE',
    'DELIVERY_NOTIFICATION',
    'FRAUD_ALERT',
    'HIGHER_EDUCATION',
    'LOW_VOLUME',
    'MARKETING',
    'MIXED',
    'POLLING_VOTING',
    'PUBLIC_SERVICE_ANNOUNCEMENT',
    'SECURITY_ALERT',
    'STARTER',
  ],
  StockExchangeEnum: [
    'NASDAQ',
    'NYSE',
    'AMEX',
    'AMX',
    'ASX',
    'B3',
    'BME',
    'BSE',
    'FRA',
    'ICEX ',
    'JPX',
    'JSE',
    'KRX ',
    'LON',
    'NSE',
    'OMX',
    'SEHK',
    'SGX',
    'SSE',
    'STO',
    'SWX',
    'SZSE',
    'TSX ',
    'TWSE',
    'VSE',
    'OTHER',
  ],
  SeniorityEnum: ['DIRECTOR', 'GM', 'VP', 'CEO', 'CFO', 'GENERAL_COUNSEL', 'OTHER'],
  EntityTypeEnum: ['PRIVATE', 'PUBLIC', 'NON_PROFIT', 'GOVERNMENT', 'INDIVIDUAL'],
};

export const optionsErrorCodes = [
  'OFFLINE',
  'UNSENT',
  'LOW_DLR',
  'LOW_CTR',
  'WEAK_NETWORK',
  'SERVICE_UNAVAILABLE',
  'MAX_QUEUE',
  'GENERIC_FAILURE',
  'SMS_OFF',
  'MMS_OFF',
  'SMS_ON',
  'MMS_ON',
];

export const optionsUnitCarrierBandwidth = [
  {
    label: 'Day',
    value: 'day',
  },
  {
    label: 'Hour',
    value: 'hour',
  },
  {
    label: 'Minute',
    value: 'minute',
  },
];

export const UNAUTHORIZED = 'Unauthorized';
export const messageTypeChart = {
  SMS: 'SMS',
  MMS: 'MMS',
};

export const optionsSIMExpired = [
  {
    label: 'All',
    value: null,
  },
  {
    label: 'Expired',
    value: true,
  },
  {
    label: 'Live',
    value: false,
  },
];

export const DurationUnitEnum = {
  day: 'day',
  month: 'month',
};

export const optionsDurationUnit = [
  {
    label: 'Day',
    value: DurationUnitEnum.day,
  },
  {
    label: 'Month',
    value: DurationUnitEnum.month,
  },
];

export const optionsProtocol = [
  {
    label: 'All',
    value: '',
  },
  {
    label: 'A2P',
    value: 'a2p',
  },
  {
    label: 'P2P',
    value: 'p2p',
  },
];

export const sendMethods = {
  oneWay: 1,
  twoWays: 2,
};
export const optionsSendMethod = [
  {
    label: 'All',
    value: '',
  },
  {
    label: 'One way',
    value: sendMethods.oneWay,
  },
  {
    label: 'Two ways',
    value: sendMethods.twoWays,
  },
];

export const optionsCostType = [
  {
    label: 'All',
    value: '',
  },
  {
    label: 'Per message',
    value: 0,
  },
  {
    label: 'Per DID',
    value: 1,
  },
];

export const optionsShareable = [
  {
    label: 'All',
    value: null,
  },
  {
    label: 'Yes',
    value: true,
  },
  {
    label: 'No',
    value: false,
  },
];

export const optionsStable = [
  {
    label: 'All',
    value: null,
  },
  {
    label: 'Stable',
    value: true,
  },
  {
    label: 'Unstable',
    value: false,
  },
];

export const optionsYesNo = [
  {
    label: 'All',
    value: '',
  },
  {
    label: 'Yes',
    value: true,
  },
  {
    label: 'No',
    value: false,
  },
];

export const optionsOccupied = [
  {
    label: 'All',
    value: '',
  },
  {
    label: 'In used',
    value: true,
  },
  {
    label: 'Free',
    value: false,
  },
];

export const optionsProgress = [
  {
    label: 'All',
    value: '',
  },
  {
    label: 'In progress',
    value: true,
  },
  {
    label: 'Not in progress',
    value: false,
  },
];

export const optionsStatus = [
  {
    label: 'All',
    value: '',
  },
  {
    label: 'Online',
    value: true,
  },
  {
    label: 'Offline',
    value: false,
  },
];

export const optionsStatusOrder = [
  {
    label: 'All',
    value: '',
  },
  {
    label: 'Open',
    value: 'open',
  },
  {
    label: 'Processing',
    value: 'processing',
  },
  {
    label: 'Done',
    value: 'done',
  },
  {
    label: 'Cancelled',
    value: 'cancelled',
  },
];

export const optionsUpdateOrder = [
  {
    label: 'Processing',
    value: 'processing',
  },
  {
    label: 'Done',
    value: 'done',
  },
  {
    label: 'Cancelled',
    value: 'cancelled',
  },
];

export const optionActiveInActive = [
  {
    label: 'Active',
    value: '1',
  },
  {
    label: 'Inactive',
    value: '0',
  },
];

export const typeDaysChart = {
  '7Days': '7days',
  '30Days': '30Days',
};

export const sortDirectionEnum = {
  ASC: 'ASC',
  DESC: 'DESC',
};

export const sortDirectionOptions = [
  {
    label: 'ASC',
    value: sortDirectionEnum.ASC,
  },
  {
    label: 'DESC',
    value: sortDirectionEnum.DESC,
  },
];

export const typeDataTrigger = [
  {
    label: 'Delivered',
    value: 1,
  },
  {
    label: 'Replier',
    value: 5,
  },
  {
    label: 'Clicker',
    value: 4,
  },
];

export const statusTickets = [
  {
    label: 'All',
    value: -1,
    className: 'all',
  },
  {
    label: 'To do',
    value: 0,
    className: 'danger',
  },
  {
    label: 'In progress',
    value: 1,
    className: 'processing',
  },
  {
    label: 'Testing',
    value: 2,
    className: 'pending',
  },
  {
    label: 'Done',
    value: 3,
    className: 'success',
  },
];

export const statusNotification = {
  unread: 'unread',
  read: 'read',
};

export const actionTypeManageContact = {
  searchDeviceGroups: 'searchDeviceGroups',
  getDeviceGroups: 'getDeviceGroups',
};

export const typeUploadUrl = {
  upload: 'upload',
  url: 'url',
};

export const errorTypeInbox = [
  {
    label: 'Unknown',
    value: -1,
  },
  {
    label: 'Optout',
    value: 0,
  },
  {
    label: 'Phone number not available',
    value: 1,
  },
  {
    label: 'Message was flagged as spam',
    value: 2,
  },
];

export const carrierOptions = ['AT&T', 'Sprint', 'T-Mobile', 'U.S. Cellular', 'Verizon', 'Other'];

export const gendersForTarget = [
  { label: 'Male', value: 'M' },
  { label: 'Female', value: 'F' },
];

export const typeContacts = {
  myData: '0',
  triggerData: '1',
  aiData: '2',
  blacklistData: '3',
};

export const defaultFilter = {
  sortFields: 'createDate',
  sortDirections: 'DESC',
  pageSize: 50,
  pageIndex: 0,
  pageCount: 100,
  searchValues: '',
};

export const THEME_TYPE = {
  dark: 'tw-dark',
  light: 'light-theme',
};

export const TriggerTypes = {
  Inbound: 0,
  LeadInbound: 1,
};

export const MAXIMUM_SIZE_UPLOAD = 300; // MB
export const DEFAULT_OFFSET_LOAD_MORE = 10;

export const TIME_OUT_REQUEST_NOTIFICATION = 10000; // ms
export const TIME_OUT_CLOSE_TOAST = 5000; // ms
export const TIME_OUT_DEBOUNCE_INPUT = 400; // ms

export const stateCampaign = {
  RUNNING: 'running',
  COMPLETED: 'completed',
  PAUSED: 'paused',
};

export const stateOffer = {
  OFFER: 'offer',
  PREFILL_OFFER: 'prefill',
  NO_OFFER: 'no',
  ON_FLY: 'onfly',
};

export const intentExplanation = [
  [
    'OPTIN GENERAL CONSENT',
    'Formal requests to opt-in such as "signup", "subscribe me" etc. This is where your contacts text into the system first. Does not apply to imported lists.',
  ],
  [
    'OPTIN REQUEST FOR DEALS',
    'Not a formal opt-in but phrases like "Any specials?", "Any deals right now?", "Have a coupon?" etc. still qualify as opt-ins.',
  ],
  [
    'OPTOUT REQUEST',
    'Our AI can detect millions of ways someone might opt out. If we miss any, add those keywords in the keywords box.',
  ],
  [
    'MENU',
    'This is the only responder that can be triggered up to 5 times in a short period of time because people need immediate access to the Menu responder.',
  ],
  [
    'REQUEST TO BE CONTACTED',
    'When the contact wants you to contact them for various reasons they may say something like "Someone call me" or "Contact me."',
  ],
  [
    'HOURS OF OPERATION',
    'When someone asks you "What are your hours?" you need to have a good response.',
  ],
  [
    'LOCATION REQUEST',
    '"Where are you located" is a typical example and you should text back an address or a maps link.',
  ],
  [
    'ARRIVAL TIME',
    'Typically this responder is for phrases like "When will you get here" or "Are you coming?" etc.',
  ],
  [
    'ARRIVAL TIME RESPONSE',
    `"I will be there in a min", "I'm on my way", "ETA is about 20 minutes", etc.`,
  ],
  [
    'CUSTOMER SERVICE',
    `I need help" and "I would like to speak with a customer service rep" are examples of contacts requesting help.`,
  ],
  [
    'INFORMATION REQUEST',
    `"What?", "Huh?", "Please explain" are examples of contact asking for more info to clarify what you said.`,
  ],
  [
    'INFORMATION RESPONSE',
    `"What's your question?", "What do you need to know?" etc. are examples of how a contact may respond to after receiving INFORMATION REQUEST reply.`,
  ],
  [
    'INTENT QUESTION',
    `"Why are you texting me", "What are you selling me?" etc are examples of contacts who need more clarification as to "Why" you are texting them.`,
  ],
  [
    'IDENTITY QUESTION',
    `"Who is this?", "Who are you?" etc. are examples of contacts asking for you to clarify who you or your business is.`,
  ],
  [
    'ABOUT SELF RESPONSE',
    `"I have black hair", "I am 39 years old", and "What would you like to know about me?" etc. are examples of what contacts may ask or say after triggering "ABOUT SELF QUESTION"`,
  ],
  [
    'GREETING',
    `"Hi","Hello","Howdy", etc. are examples of direct greetings that contacts use to initiate the start of a conversation.`,
  ],
  [
    'GREETING RESPONSE',
    `"Hello back", "Well hi to you as well", "Sup back" etc. are examples of how contacts will respond to triggering GREETING responder.`,
  ],
  [
    'QUESTION GREETING',
    `"Whats up?", "How goes it?", "How are you?" are examples of greetings in the form of a question.`,
  ],
  [
    'QUESTION GREETING RESPONSE',
    `"Great and you?", "Doing well thanks", "Fine, and you?" are typical responses when contact triggers QUESTION GREETING responder.`,
  ],
  [
    'NICE MEETING',
    `"Nice meeting you", "Nice talking to you", Nice chatting" are examples of salutations showing appreciation for the conversation.`,
  ],
  [
    'NOT WELL',
    `"I'm ill", "I'm sick", "Not doing so hot" are examples of potential responses to QUESTION GREETING that you may want to have a more precise reply for.`,
  ],
  [
    'NICE TALKING',
    `Similar to NICE MEETING but again, allows your response to be more fine-tuned.`,
  ],
  [
    'GOODBYE',
    `Typically a conversation ender. However, this does not usually equal an opt-out but it could if they word it like: "Stop texting me. Goodbye!"`,
  ],
  [
    'GOOD NIGHT',
    'Salutation for the evening. Sometimes contacts will trigger this at night so watch your Sleep Timer in Settings Tab.',
  ],
  [
    'THANKS',
    `"Thank you","Great thanks!","Thanks" are examples where "You are welcome" etc. are typically appropriate responses.`,
  ],
  [
    'THANKS RESPONSE',
    `The contact may text in "You are welcome.", "You're welcome" etc. and this responder is where you reply to that.`,
  ],
  [
    'COMPLIMENT',
    `"You are amazing!", "Loved the food", "Fantastic service", are examples of compliments that you should respond to.`,
  ],
  [
    'COMPLIMENT RESPONSE',
    `"You're not so bad yourself", "You are too kind" etc. are ways contacts may respond. When they do, you can set what is sent next.`,
  ],
  [
    'POSITIVE RESPONSE',
    `"You're not so bad yourself", "You are too kind" etc. are ways contacts may respond. When they do, you can set what is sent next.`,
  ],
  [
    'APPRECIATION',
    `"Thanks", "Thank you!", "Appreciate it" are examples of how contacts may respond when they are happy so make sure your response is positive.`,
  ],
  [
    'LOVE YOU',
    `Although this is very similar to APPRECIATION, this responder allows you to give a custom greeting when contacts say things like "Love it!", "Love your service", "Love your company!", etc.`,
  ],
  [
    'LOVE YOU RESPONSE',
    `When contacts say "Love it too", "Also love your service", "Love your company as well!", etc. what do you want to send next?`,
  ],
  [
    'MISS YOU',
    `If you say "Missed you today" or "Missed your appointment?" etc. to users and they reply with similar keywords, what do you want to trigger next?`,
  ],
  [
    'NOT INTERESTED',
    `"No thanks", "Not interested", "Not right now", etc. are some ways contacts may state they are not interested but they are not actually opting out.`,
  ],
  [
    'DISSATISFACTION',
    `"I'm upset!", "Your staff was unprofessional!", "Bad service", etc. are ways contacts indicate they are dissatisfied and you should take action.`,
  ],
  [
    'INSULT',
    `This is where contacts say obscenities or otherwise try to insult you or our AI. This is where you mitigate you most irate. If someone replies “Eat a dick” you can reply with: No need for that kind of language, I am only doing my job. I will delete you from the list!`,
  ],
  [
    'INSULT RESPONSE',
    `If your response to INSULT is misinterpreted as arguing, contacts may say "You are rude", "Your point?", "Ridiculous", etc. which are not direct insults but you should respond anyway.`,
  ],
  [
    'APOLOGY',
    `Many times contacts will accidentally text in thinking they are texting someone else. When that happens and they notice they usually text things like "Oops sorry", "Wrong chat my bad", "My mistake", etc.`,
  ],
  [
    'Catch All',
    `If no other responders trigger (with the exception of the Sequential responders), you can trigger this catch-all. Often used in compo with the Text Forwarding feature.`,
  ],
];

export const TypoStatus = ({ color, text }) => (
  <span style={{ color, fontWeight: 600 }}>{text}</span>
);

export const topDomainDefault = [
  { label: 'xyz', value: 'xyz' },
  { label: 'site', value: 'site' },
  { label: 'club', value: 'club' },
  { label: 'com', value: 'com' },
];

export const listDate = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export const optionFilterHistory = [
  {
    label: 'Running',
    value: 'running',
  },
  {
    label: 'Scheduled',
    value: 'scheduled',
  },
  {
    label: 'Completed',
    value: 'completed',
  },
  {
    label: 'Paused',
    value: 'paused',
  },
];

export const optionFieldFilter = [
  {
    label: 'Username',
    value: 'username',
  },
  {
    label: 'First Name',
    value: 'firstname',
  },
  {
    label: 'Last Name',
    value: 'lastname',
  },
  {
    label: 'Email',
    value: 'email',
  },
  {
    label: 'Balance',
    value: 'balance',
  },
  {
    label: 'Role',
    value: 'role',
  },
  {
    label: 'Route',
    value: 'route',
  },
];

export const optionBalanceOperator = [
  {
    label: 'Equals to',
    value: 'eq',
  },
  {
    label: 'Greater than',
    value: 'gt',
  },
  {
    label: 'Less than',
    value: 'lt',
  },
];

export const optionMessageError = [
  {
    label: 'Unknown',
    value: -1,
  },
  {
    label: 'Optout',
    value: 0,
  },
  {
    label: 'Phone number not available',
    value: 1,
  },
];

export const rangeTimeOption = [
  {
    label: 'Today',
    value: 'Today',
  },
  {
    label: 'Yesterday',
    value: 'Yesterday',
  },
  {
    label: 'Last 3 Days',
    value: 'Last3Days',
  },
  {
    label: 'Last 7 Days',
    value: 'Last7Days',
  },
  {
    label: 'This Month',
    value: 'ThisMonth',
  },
  {
    label: 'Last 30 Days',
    value: 'Last30Days',
  },
  {
    label: 'Last Month',
    value: 'LastMonth',
  },
  // {
  // 	label: 'Last Billing Cycle',
  // 	value: 'LastBillingCycle'
  // },
  {
    label: 'Last 90 Days',
    value: 'Last90Days',
  },
  {
    label: 'All Time',
    value: 'AllTime',
  },
];

const timezonesJson = {
  'Pacific/Niue': '(GMT-11:00) Niue',
  'Pacific/Pago_Pago': '(GMT-11:00) Pago Pago',
  'Pacific/Honolulu': '(GMT-10:00) Hawaii Time',
  'Pacific/Rarotonga': '(GMT-10:00) Rarotonga',
  'Pacific/Tahiti': '(GMT-10:00) Tahiti',
  'America/Anchorage': '(GMT-09:00) Alaska Time',
  'Pacific/Gambier': '(GMT-09:00) Gambier',
  'America/Los_Angeles': '(GMT-08:00) Pacific Time',
  'America/Tijuana': '(GMT-08:00) Pacific Time - Tijuana',
  'America/Vancouver': '(GMT-08:00) Pacific Time - Vancouver',
  'America/Whitehorse': '(GMT-08:00) Pacific Time - Whitehorse',
  'Pacific/Pitcairn': '(GMT-08:00) Pitcairn',
  'America/Dawson_Creek': '(GMT-07:00) Mountain Time - Dawson Creek',
  'America/Denver': '(GMT-07:00) Mountain Time',
  'America/Edmonton': '(GMT-07:00) Mountain Time - Edmonton',
  'America/Hermosillo': '(GMT-07:00) Mountain Time - Hermosillo',
  'America/Mazatlan': '(GMT-07:00) Mountain Time - Chihuahua, Mazatlan',
  'America/Phoenix': '(GMT-07:00) Mountain Time - Arizona',
  'America/Yellowknife': '(GMT-07:00) Mountain Time - Yellowknife',
  'America/Belize': '(GMT-06:00) Belize',
  'America/Chicago': '(GMT-06:00) Central Time',
  'America/Costa_Rica': '(GMT-06:00) Costa Rica',
  'America/El_Salvador': '(GMT-06:00) El Salvador',
  'America/Guatemala': '(GMT-06:00) Guatemala',
  'America/Managua': '(GMT-06:00) Managua',
  'America/Mexico_City': '(GMT-06:00) Central Time - Mexico City',
  'America/Regina': '(GMT-06:00) Central Time - Regina',
  'America/Tegucigalpa': '(GMT-06:00) Central Time - Tegucigalpa',
  'America/Winnipeg': '(GMT-06:00) Central Time - Winnipeg',
  'Pacific/Galapagos': '(GMT-06:00) Galapagos',
  'America/Bogota': '(GMT-05:00) Bogota',
  'America/Cancun': '(GMT-05:00) America Cancun',
  'America/Cayman': '(GMT-05:00) Cayman',
  'America/Guayaquil': '(GMT-05:00) Guayaquil',
  'America/Havana': '(GMT-05:00) Havana',
  'America/Iqaluit': '(GMT-05:00) Eastern Time - Iqaluit',
  'America/Jamaica': '(GMT-05:00) Jamaica',
  'America/Lima': '(GMT-05:00) Lima',
  'America/Nassau': '(GMT-05:00) Nassau',
  'America/New_York': '(GMT-05:00) Eastern Time',
  'America/Panama': '(GMT-05:00) Panama',
  'America/Port-au-Prince': '(GMT-05:00) Port-au-Prince',
  'America/Rio_Branco': '(GMT-05:00) Rio Branco',
  'America/Toronto': '(GMT-05:00) Eastern Time - Toronto',
  'Pacific/Easter': '(GMT-05:00) Easter Island',
  'America/Barbados': '(GMT-04:00) Barbados',
  'America/Boa_Vista': '(GMT-04:00) Boa Vista',
  'America/Curacao': '(GMT-04:00) Curacao',
  'America/Grand_Turk': '(GMT-04:00) Grand Turk',
  'America/Guyana': '(GMT-04:00) Guyana',
  'America/Halifax': '(GMT-04:00) Atlantic Time - Halifax',
  'America/La_Paz': '(GMT-04:00) La Paz',
  'America/Manaus': '(GMT-04:00) Manaus',
  'America/Martinique': '(GMT-04:00) Martinique',
  'America/Port_of_Spain': '(GMT-04:00) Port of Spain',
  'America/Porto_Velho': '(GMT-04:00) Porto Velho',
  'America/Puerto_Rico': '(GMT-04:00) Puerto Rico',
  'America/Santo_Domingo': '(GMT-04:00) Santo Domingo',
  'America/Thule': '(GMT-04:00) Thule',
  'Atlantic/Bermuda': '(GMT-04:00) Bermuda',
  'America/Asuncion': '(GMT-03:00) Asuncion',
  'America/Campo_Grande': '(GMT-03:00) Campo Grande',
  'America/Cuiaba': '(GMT-03:00) Cuiaba',
  'America/Araguaina': '(GMT-03:00) Araguaina',
  'America/Argentina/Buenos_Aires': '(GMT-03:00) Buenos Aires',
  'America/Bahia': '(GMT-03:00) Salvador',
  'America/Belem': '(GMT-03:00) Belem',
  'America/Cayenne': '(GMT-03:00) Cayenne',
  'America/Fortaleza': '(GMT-03:00) Fortaleza',
  'America/Godthab': '(GMT-03:00) Godthab',
  'America/Maceio': '(GMT-03:00) Maceio',
  'America/Miquelon': '(GMT-03:00) Miquelon',
  'America/Montevideo': '(GMT-03:00) Montevideo',
  'America/Paramaribo': '(GMT-03:00) Paramaribo',
  'America/Recife': '(GMT-03:00) Recife',
  'America/Santiago': '(GMT-03:00) Santiago',
  'Antarctica/Palmer': '(GMT-03:00) Palmer',
  'Antarctica/Rothera': '(GMT-03:00) Rothera',
  'Atlantic/Stanley': '(GMT-03:00) Stanley',
  'America/Sao_Paulo': '(GMT-02:00) Sao Paulo',
  'America/Noronha': '(GMT-02:00) Noronha',
  'Atlantic/South_Georgia': '(GMT-02:00) South Georgia',
  'America/Scoresbysund': '(GMT-01:00) Scoresbysund',
  'Atlantic/Azores': '(GMT-01:00) Azores',
  'Atlantic/Cape_Verde': '(GMT-01:00) Cape Verde',
  'Africa/Abidjan': '(GMT+00:00) Abidjan',
  'Africa/Accra': '(GMT+00:00) Accra',
  'Africa/Bissau': '(GMT+00:00) Bissau',
  'Africa/Casablanca': '(GMT+00:00) Casablanca',
  'Africa/El_Aaiun': '(GMT+00:00) El Aaiun',
  'Africa/Monrovia': '(GMT+00:00) Monrovia',
  'America/Danmarkshavn': '(GMT+00:00) Danmarkshavn',
  'Atlantic/Canary': '(GMT+00:00) Canary Islands',
  'Atlantic/Faroe': '(GMT+00:00) Faeroe',
  'Atlantic/Reykjavik': '(GMT+00:00) Reykjavik',
  'Etc/GMT': '(GMT+00:00) GMT (no daylight saving)',
  'Europe/Dublin': '(GMT+00:00) Dublin',
  'Europe/Lisbon': '(GMT+00:00) Lisbon',
  'Europe/London': '(GMT+00:00) London',
  'Africa/Algiers': '(GMT+01:00) Algiers',
  'Africa/Ceuta': '(GMT+01:00) Ceuta',
  'Africa/Lagos': '(GMT+01:00) Lagos',
  'Africa/Ndjamena': '(GMT+01:00) Ndjamena',
  'Africa/Tunis': '(GMT+01:00) Tunis',
  'Europe/Amsterdam': '(GMT+01:00) Amsterdam',
  'Europe/Andorra': '(GMT+01:00) Andorra',
  'Europe/Belgrade': '(GMT+01:00) Central European Time - Belgrade',
  'Europe/Berlin': '(GMT+01:00) Berlin',
  'Europe/Brussels': '(GMT+01:00) Brussels',
  'Europe/Budapest': '(GMT+01:00) Budapest',
  'Europe/Copenhagen': '(GMT+01:00) Copenhagen',
  'Europe/Gibraltar': '(GMT+01:00) Gibraltar',
  'Europe/Luxembourg': '(GMT+01:00) Luxembourg',
  'Europe/Madrid': '(GMT+01:00) Madrid',
  'Europe/Malta': '(GMT+01:00) Malta',
  'Europe/Monaco': '(GMT+01:00) Monaco',
  'Europe/Oslo': '(GMT+01:00) Oslo',
  'Europe/Paris': '(GMT+01:00) Paris',
  'Europe/Prague': '(GMT+01:00) Central European Time - Prague',
  'Europe/Rome': '(GMT+01:00) Rome',
  'Europe/Stockholm': '(GMT+01:00) Stockholm',
  'Europe/Tirane': '(GMT+01:00) Tirane',
  'Europe/Vienna': '(GMT+01:00) Vienna',
  'Europe/Warsaw': '(GMT+01:00) Warsaw',
  'Europe/Zurich': '(GMT+01:00) Zurich',
  'Africa/Windhoek': '(GMT+02:00) Windhoek',
  'Africa/Cairo': '(GMT+02:00) Cairo',
  'Africa/Johannesburg': '(GMT+02:00) Johannesburg',
  'Africa/Maputo': '(GMT+02:00) Maputo',
  'Africa/Tripoli': '(GMT+02:00) Tripoli',
  'Asia/Amman': '(GMT+02:00) Amman',
  'Asia/Beirut': '(GMT+02:00) Beirut',
  'Asia/Damascus': '(GMT+02:00) Damascus',
  'Asia/Gaza': '(GMT+02:00) Gaza',
  'Asia/Jerusalem': '(GMT+02:00) Jerusalem',
  'Asia/Nicosia': '(GMT+02:00) Nicosia',
  'Europe/Athens': '(GMT+02:00) Athens',
  'Europe/Bucharest': '(GMT+02:00) Bucharest',
  'Europe/Chisinau': '(GMT+02:00) Chisinau',
  'Europe/Helsinki': '(GMT+02:00) Helsinki',
  'Europe/Istanbul': '(GMT+02:00) Istanbul',
  'Europe/Kaliningrad': '(GMT+02:00) Moscow-01 - Kaliningrad',
  'Europe/Kiev': '(GMT+02:00) Kiev',
  'Europe/Riga': '(GMT+02:00) Riga',
  'Europe/Sofia': '(GMT+02:00) Sofia',
  'Europe/Tallinn': '(GMT+02:00) Tallinn',
  'Europe/Vilnius': '(GMT+02:00) Vilnius',
  'Africa/Khartoum': '(GMT+03:00) Khartoum',
  'Africa/Nairobi': '(GMT+03:00) Nairobi',
  'Antarctica/Syowa': '(GMT+03:00) Syowa',
  'Asia/Baghdad': '(GMT+03:00) Baghdad',
  'Asia/Qatar': '(GMT+03:00) Qatar',
  'Asia/Riyadh': '(GMT+03:00) Riyadh',
  'Europe/Minsk': '(GMT+03:00) Minsk',
  'Europe/Moscow': '(GMT+03:00) Moscow+00 - Moscow',
  'Asia/Baku': '(GMT+04:00) Baku',
  'Asia/Dubai': '(GMT+04:00) Dubai',
  'Asia/Tbilisi': '(GMT+04:00) Tbilisi',
  'Asia/Yerevan': '(GMT+04:00) Yerevan',
  'Europe/Samara': '(GMT+04:00) Moscow+01 - Samara',
  'Indian/Mahe': '(GMT+04:00) Mahe',
  'Indian/Mauritius': '(GMT+04:00) Mauritius',
  'Indian/Reunion': '(GMT+04:00) Reunion',
  'Antarctica/Mawson': '(GMT+05:00) Mawson',
  'Asia/Aqtau': '(GMT+05:00) Aqtau',
  'Asia/Aqtobe': '(GMT+05:00) Aqtobe',
  'Asia/Ashgabat': '(GMT+05:00) Ashgabat',
  'Asia/Dushanbe': '(GMT+05:00) Dushanbe',
  'Asia/Karachi': '(GMT+05:00) Karachi',
  'Asia/Tashkent': '(GMT+05:00) Tashkent',
  'Asia/Yekaterinburg': '(GMT+05:00) Moscow+02 - Yekaterinburg',
  'Indian/Kerguelen': '(GMT+05:00) Kerguelen',
  'Indian/Maldives': '(GMT+05:00) Maldives',
  'Antarctica/Vostok': '(GMT+06:00) Vostok',
  'Asia/Almaty': '(GMT+06:00) Almaty',
  'Asia/Bishkek': '(GMT+06:00) Bishkek',
  'Asia/Dhaka': '(GMT+06:00) Dhaka',
  'Asia/Omsk': '(GMT+06:00) Moscow+03 - Omsk, Novosibirsk',
  'Asia/Thimphu': '(GMT+06:00) Thimphu',
  'Indian/Chagos': '(GMT+06:00) Chagos',
  'Antarctica/Davis': '(GMT+07:00) Davis',
  'Asia/Bangkok': '(GMT+07:00) Bangkok',
  'Asia/Hovd': '(GMT+07:00) Hovd',
  'Asia/Jakarta': '(GMT+07:00) Jakarta',
  'Asia/Krasnoyarsk': '(GMT+07:00) Moscow+04 - Krasnoyarsk',
  'Asia/Saigon': '(GMT+07:00) Hanoi',
  'Asia/Ho_Chi_Minh': '(GMT+07:00) Ho Chi Minh',
  'Indian/Christmas': '(GMT+07:00) Christmas',
  'Antarctica/Casey': '(GMT+08:00) Casey',
  'Asia/Brunei': '(GMT+08:00) Brunei',
  'Asia/Choibalsan': '(GMT+08:00) Choibalsan',
  'Asia/Hong_Kong': '(GMT+08:00) Hong Kong',
  'Asia/Irkutsk': '(GMT+08:00) Moscow+05 - Irkutsk',
  'Asia/Kuala_Lumpur': '(GMT+08:00) Kuala Lumpur',
  'Asia/Macau': '(GMT+08:00) Macau',
  'Asia/Makassar': '(GMT+08:00) Makassar',
  'Asia/Manila': '(GMT+08:00) Manila',
  'Asia/Shanghai': '(GMT+08:00) China Time - Beijing',
  'Asia/Singapore': '(GMT+08:00) Singapore',
  'Asia/Taipei': '(GMT+08:00) Taipei',
  'Asia/Ulaanbaatar': '(GMT+08:00) Ulaanbaatar',
  'Australia/Perth': '(GMT+08:00) Western Time - Perth',
  'Asia/Dili': '(GMT+09:00) Dili',
  'Asia/Jayapura': '(GMT+09:00) Jayapura',
  'Asia/Seoul': '(GMT+09:00) Seoul',
  'Asia/Tokyo': '(GMT+09:00) Tokyo',
  'Asia/Yakutsk': '(GMT+09:00) Moscow+06 - Yakutsk',
  'Pacific/Palau': '(GMT+09:00) Palau',
  'Antarctica/DumontDUrville': "(GMT+10:00) Dumont D'Urville",
  'Asia/Magadan': '(GMT+10:00) Moscow+07 - Magadan',
  'Asia/Vladivostok': '(GMT+10:00) Moscow+07 - Yuzhno-Sakhalinsk',
  'Australia/Brisbane': '(GMT+10:00) Eastern Time - Brisbane',
  'Pacific/Chuuk': '(GMT+10:00) Truk',
  'Pacific/Guam': '(GMT+10:00) Guam',
  'Pacific/Port_Moresby': '(GMT+10:00) Port Moresby',
  'Australia/Hobart': '(GMT+11:00) Eastern Time - Hobart',
  'Australia/Sydney': '(GMT+11:00) Eastern Time - Melbourne, Sydney',
  'Pacific/Efate': '(GMT+11:00) Efate',
  'Pacific/Guadalcanal': '(GMT+11:00) Guadalcanal',
  'Pacific/Kosrae': '(GMT+11:00) Kosrae',
  'Pacific/Norfolk': '(GMT+11:00) Norfolk',
  'Pacific/Noumea': '(GMT+11:00) Noumea',
  'Pacific/Pohnpei': '(GMT+11:00) Ponape',
  'Asia/Kamchatka': '(GMT+12:00) Moscow+09 - Petropavlovsk-Kamchatskiy',
  'Pacific/Funafuti': '(GMT+12:00) Funafuti',
  'Pacific/Kwajalein': '(GMT+12:00) Kwajalein',
  'Pacific/Majuro': '(GMT+12:00) Majuro',
  'Pacific/Nauru': '(GMT+12:00) Nauru',
  'Pacific/Tarawa': '(GMT+12:00) Tarawa',
  'Pacific/Wake': '(GMT+12:00) Wake',
  'Pacific/Wallis': '(GMT+12:00) Wallis',
  'Pacific/Auckland': '(GMT+13:00) Auckland',
  'Pacific/Fiji': '(GMT+13:00) Fiji',
  'Pacific/Enderbury': '(GMT+13:00) Enderbury',
  'Pacific/Fakaofo': '(GMT+13:00) Fakaofo',
  'Pacific/Tongatapu': '(GMT+13:00) Tongatapu',
  'Pacific/Apia': '(GMT+14:00) Apia',
  'Pacific/Kiritimati': '(GMT+14:00) Kiritimati',
};

export const timezoneUTC = 'Etc/GMT';

export const timezones = Object.keys(timezonesJson)
  .reduce((arr, key) => {
    const tempObj = {
      label: `${timezonesJson[key].split(' ')[0]} ${key}`,
      value: key,
    };

    arr = [...arr, tempObj];
    return arr;
  }, [])
  .sort((a, b) => a.label.localeCompare(b.label));

export const getTimezoneText = (timeZoneName) => {
  return (timezones || []).find((time) => time.value === timeZoneName)?.label || '';
};

export const methodOption = ['POST', 'GET'];

export const sendTypeOption = [
  {
    label: 'Send an email on every inbound text',
    value: 'everyInbound',
  },
  {
    label: 'Once every 24 hours',
    value: 'every24h',
  },
  {
    label: 'Once every 12 hours',
    value: 'every12h',
  },
  {
    label: 'Once every 8 hours',
    value: 'every8h',
  },
  {
    label: 'Once every 4 hours',
    value: 'every4h',
  },
  {
    label: 'Once every 2 hours',
    value: 'every2h',
  },
  {
    label: 'Once every hour',
    value: 'every1h',
  },
  {
    label: 'Once every 30 minutes',
    value: 'every30min',
  },
];

export const messageType = {
  smsSpintax: 'SMS',
  mms: 'MMS',
  mmse: 'MMSE',
  voice: 'VOICE',
  ringlessVoicemail: 'RVM',
  email2SMS: 'SMS2',
  RVM: 'RVM',
  RCS: 'RCS',
};

//* Tricky
export const messageTypeEnum = messageType;

export const ModemBrandOptions = {
  'Ejoin Modem': 'ejoin_modem',
  'Ejoin Modem Ext': 'ejoin_modem_ext',
};

export const ModemServiceTypes = {
  sms: 'SMS',
  mms: 'MMS',
  rvm: 'RVM',
};

export const optionsMessageType = [
  {
    label: 'All',
    value: '',
  },
  {
    label: 'SMS',
    value: 'SMS',
  },
  {
    label: 'SMS2',
    value: messageType.email2SMS,
  },
  {
    label: 'MMS',
    value: 'MMS',
  },
  {
    label: 'MMSE',
    value: messageType.mmse,
  },
  {
    label: 'Voice',
    value: messageType.voice,
  },
  {
    label: 'Ringless Voicemail',
    value: messageType.ringlessVoicemail,
  },
  {
    label: 'RCS',
    value: messageType.RCS,
  },
];

export const messageTypeOptions = [
  {
    label: 'SMS',
    value: messageType.smsSpintax,
  },
  {
    label: 'SMS2',
    value: messageType.email2SMS,
  },
  {
    label: 'MMS',
    value: messageType.mms,
  },
  {
    label: 'MMSE',
    value: messageType.mmse,
  },
  {
    label: 'Voice',
    value: messageType.voice,
  },
  {
    label: 'Ringless Voicemail',
    value: messageType.ringlessVoicemail,
  },
];

export const roles = [
  rolesAccount.managementAgency,
  rolesAccount.businessUser,
  rolesAccount.farmWorker,
  rolesAccount.farmManager,
];
export const industries =
  'Sales & Marketing;Social Media & Blogging;SEO & PPC;Affiliate & Lead Generation;In & Outbound Call Centers;Telecom & Communications;Schools & Education;Safety & Security;IT & Infrastructure;Customer & Technical Support;Web & Mobile Development;Spas & Massage;Nail & Hair Salons;Health & Wellness;Hotels & Hospitality;Physicians & Doctors;Dental & Orthodontics;Restaurants & Food;Retail & Boutiques;Bars & Night Clubs;Tourism & Attractions;Entertainment & Shows;Real Estate Leasing & Rentals;Mortgage & Real Estate Brokage;Industrial Leasing & Rentals;Regulatory & Legal Services;Auto Sales & Lending;Personal Loans & Lending;Business  Loans & Lending;Accounting & Bookkeeping;Tax Advice & Preparation;Payroll & 401k Services;HR & Recruiting;Home, Auto & Renters Insurance;Health & Life Insurance;Business Insurance;Government & NGO;Charity & Non-Profit;Church & Religion;Transportation & Rideshare;Travel & Vacation;Industrial Monitoring;Mining & Minerals;Oil & Gas'.split(
    ';',
  );
export const statuses = ['Active', 'Inactive', 'Pending', 'Suspended', 'Banned'];

export const genders = ['Male', 'Female'];
export const optionGenders = [
  { label: 'Male', value: 'm' },
  { label: 'Female', value: 'f' },
];

export const automationTestMessageTypes = [
  { label: 'SMS', value: 'SMS' },
  { label: 'MMS', value: 'MMS' },
  { label: 'Voice', value: 'VOICE' },
];

export const automationCarriers = {
  VERIZON: 'Verizon',
  TMOBILE: 'T-Mobile',
  ATT: 'AT&T',
};

export const automationTestFieldFilter = [
  {
    label: 'Test Code',
    value: 'code',
  },
  {
    label: 'Test Name',
    value: 'name',
  },
  {
    label: 'Message',
    value: 'message',
  },
];

export const phoneTypes = [
  {
    id: 'nexmo',
    text: 'Nexmo',
  },
  {
    id: 'nexmo_c',
    text: 'Nexmo Canada',
  },
  {
    id: 'sinch',
    text: 'Sinch',
  },
  {
    id: 'sinch_inter',
    text: 'Sinch International',
  },
  {
    id: 'infobip',
    text: 'Infobip',
  },
  {
    id: 'smsgorilla',
    text: 'SMS Gorilla',
  },
  {
    id: 'mobiniti',
    text: 'Mobiniti',
  },
  {
    id: 'teli',
    text: 'Teli',
  },
  {
    id: 'compeak',
    text: 'Compeak',
  },
  {
    id: 'thinq',
    text: 'Thinq',
  },
  {
    id: 'nexmo_sippo',
    text: 'Nexmo Sippo',
  },
  {
    id: 'isp_telecom',
    text: 'ISP Telecom',
  },
  {
    id: 'voip_ms',
    text: 'VoIP MS',
  },
  {
    id: 'routee',
    text: 'Routee',
  },
];

export const listCountries = [
  {
    name: 'Andorra',
    code: 'AD',
  },
  {
    name: 'United Arab Emirates',
    code: 'AE',
  },
  {
    name: 'Afghanistan',
    code: 'AF',
  },
  {
    name: 'Antigua & Barbuda',
    code: 'AG',
  },
  {
    name: 'Anguilla',
    code: 'AI',
  },
  {
    name: 'Albania',
    code: 'AL',
  },
  {
    name: 'Armenia',
    code: 'AM',
  },
  {
    name: 'Angola',
    code: 'AO',
  },
  {
    name: 'Antarctica',
    code: 'AQ',
  },
  {
    name: 'Argentina',
    code: 'AR',
  },
  {
    name: 'American Samoa',
    code: 'AS',
  },
  {
    name: 'Austria',
    code: 'AT',
  },
  {
    name: 'Australia',
    code: 'AU',
  },
  {
    name: 'Aruba',
    code: 'AW',
  },
  {
    name: 'Åland Islands',
    code: 'AX',
  },
  {
    name: 'Azerbaijan',
    code: 'AZ',
  },
  {
    name: 'Bosnia & Herzegovina',
    code: 'BA',
  },
  {
    name: 'Barbados',
    code: 'BB',
  },
  {
    name: 'Bangladesh',
    code: 'BD',
  },
  {
    name: 'Belgium',
    code: 'BE',
  },
  {
    name: 'Burkina Faso',
    code: 'BF',
  },
  {
    name: 'Bulgaria',
    code: 'BG',
  },
  {
    name: 'Bahrain',
    code: 'BH',
  },
  {
    name: 'Burundi',
    code: 'BI',
  },
  {
    name: 'Benin',
    code: 'BJ',
  },
  {
    name: 'St. Barthélemy',
    code: 'BL',
  },
  {
    name: 'Bermuda',
    code: 'BM',
  },
  {
    name: 'Brunei',
    code: 'BN',
  },
  {
    name: 'Bolivia',
    code: 'BO',
  },
  {
    name: 'Caribbean Netherlands',
    code: 'BQ',
  },
  {
    name: 'Brazil',
    code: 'BR',
  },
  {
    name: 'Bahamas',
    code: 'BS',
  },
  {
    name: 'Bhutan',
    code: 'BT',
  },
  {
    name: 'Bouvet Island',
    code: 'BV',
  },
  {
    name: 'Botswana',
    code: 'BW',
  },
  {
    name: 'Belarus',
    code: 'BY',
  },
  {
    name: 'Belize',
    code: 'BZ',
  },
  {
    name: 'Canada',
    code: 'CA',
  },
  {
    name: 'Cocos (Keeling) Islands',
    code: 'CC',
  },
  {
    name: 'Congo - Kinshasa',
    code: 'CD',
  },
  {
    name: 'Central African Republic',
    code: 'CF',
  },
  {
    name: 'Congo - Brazzaville',
    code: 'CG',
  },
  {
    name: 'Switzerland',
    code: 'CH',
  },
  {
    name: 'Côte d’Ivoire',
    code: 'CI',
  },
  {
    name: 'Cook Islands',
    code: 'CK',
  },
  {
    name: 'Chile',
    code: 'CL',
  },
  {
    name: 'Cameroon',
    code: 'CM',
  },
  {
    name: 'China',
    code: 'CN',
  },
  {
    name: 'Colombia',
    code: 'CO',
  },
  {
    name: 'Costa Rica',
    code: 'CR',
  },
  {
    name: 'Cuba',
    code: 'CU',
  },
  {
    name: 'Cape Verde',
    code: 'CV',
  },
  {
    name: 'Curaçao',
    code: 'CW',
  },
  {
    name: 'Christmas Island',
    code: 'CX',
  },
  {
    name: 'Cyprus',
    code: 'CY',
  },
  {
    name: 'Czechia',
    code: 'CZ',
  },
  {
    name: 'Germany',
    code: 'DE',
  },
  {
    name: 'Djibouti',
    code: 'DJ',
  },
  {
    name: 'Denmark',
    code: 'DK',
  },
  {
    name: 'Dominica',
    code: 'DM',
  },
  {
    name: 'Dominican Republic',
    code: 'DO',
  },
  {
    name: 'Algeria',
    code: 'DZ',
  },
  {
    name: 'Ecuador',
    code: 'EC',
  },
  {
    name: 'Estonia',
    code: 'EE',
  },
  {
    name: 'Egypt',
    code: 'EG',
  },
  {
    name: 'Western Sahara',
    code: 'EH',
  },
  {
    name: 'Eritrea',
    code: 'ER',
  },
  {
    name: 'Spain',
    code: 'ES',
  },
  {
    name: 'Ethiopia',
    code: 'ET',
  },
  {
    name: 'Finland',
    code: 'FI',
  },
  {
    name: 'Fiji',
    code: 'FJ',
  },
  {
    name: 'Falkland Islands',
    code: 'FK',
  },
  {
    name: 'Micronesia',
    code: 'FM',
  },
  {
    name: 'Faroe Islands',
    code: 'FO',
  },
  {
    name: 'France',
    code: 'FR',
  },
  {
    name: 'Gabon',
    code: 'GA',
  },
  {
    name: 'United Kingdom',
    code: 'GB',
  },
  {
    name: 'Grenada',
    code: 'GD',
  },
  {
    name: 'Georgia',
    code: 'GE',
  },
  {
    name: 'French Guiana',
    code: 'GF',
  },
  {
    name: 'Guernsey',
    code: 'GG',
  },
  {
    name: 'Ghana',
    code: 'GH',
  },
  {
    name: 'Gibraltar',
    code: 'GI',
  },
  {
    name: 'Greenland',
    code: 'GL',
  },
  {
    name: 'Gambia',
    code: 'GM',
  },
  {
    name: 'Guinea',
    code: 'GN',
  },
  {
    name: 'Guadeloupe',
    code: 'GP',
  },
  {
    name: 'Equatorial Guinea',
    code: 'GQ',
  },
  {
    name: 'Greece',
    code: 'GR',
  },
  {
    name: 'South Georgia & South Sandwich Islands',
    code: 'GS',
  },
  {
    name: 'Guatemala',
    code: 'GT',
  },
  {
    name: 'Guam',
    code: 'GU',
  },
  {
    name: 'Guinea-Bissau',
    code: 'GW',
  },
  {
    name: 'Guyana',
    code: 'GY',
  },
  {
    name: 'Hong Kong SAR China',
    code: 'HK',
  },
  {
    name: 'Heard & McDonald Islands',
    code: 'HM',
  },
  {
    name: 'Honduras',
    code: 'HN',
  },
  {
    name: 'Croatia',
    code: 'HR',
  },
  {
    name: 'Haiti',
    code: 'HT',
  },
  {
    name: 'Hungary',
    code: 'HU',
  },
  {
    name: 'Indonesia',
    code: 'ID',
  },
  {
    name: 'Ireland',
    code: 'IE',
  },
  {
    name: 'Israel',
    code: 'IL',
  },
  {
    name: 'Isle of Man',
    code: 'IM',
  },
  {
    name: 'India',
    code: 'IN',
  },
  {
    name: 'British Indian Ocean Territory',
    code: 'IO',
  },
  {
    name: 'Iraq',
    code: 'IQ',
  },
  {
    name: 'Iran',
    code: 'IR',
  },
  {
    name: 'Iceland',
    code: 'IS',
  },
  {
    name: 'Italy',
    code: 'IT',
  },
  {
    name: 'Jersey',
    code: 'JE',
  },
  {
    name: 'Jamaica',
    code: 'JM',
  },
  {
    name: 'Jordan',
    code: 'JO',
  },
  {
    name: 'Japan',
    code: 'JP',
  },
  {
    name: 'Kenya',
    code: 'KE',
  },
  {
    name: 'Kyrgyzstan',
    code: 'KG',
  },
  {
    name: 'Cambodia',
    code: 'KH',
  },
  {
    name: 'Kiribati',
    code: 'KI',
  },
  {
    name: 'Comoros',
    code: 'KM',
  },
  {
    name: 'St. Kitts & Nevis',
    code: 'KN',
  },
  {
    name: 'North Korea',
    code: 'KP',
  },
  {
    name: 'South Korea',
    code: 'KR',
  },
  {
    name: 'Kuwait',
    code: 'KW',
  },
  {
    name: 'Cayman Islands',
    code: 'KY',
  },
  {
    name: 'Kazakhstan',
    code: 'KZ',
  },
  {
    name: 'Laos',
    code: 'LA',
  },
  {
    name: 'Lebanon',
    code: 'LB',
  },
  {
    name: 'St. Lucia',
    code: 'LC',
  },
  {
    name: 'Liechtenstein',
    code: 'LI',
  },
  {
    name: 'Sri Lanka',
    code: 'LK',
  },
  {
    name: 'Liberia',
    code: 'LR',
  },
  {
    name: 'Lesotho',
    code: 'LS',
  },
  {
    name: 'Lithuania',
    code: 'LT',
  },
  {
    name: 'Luxembourg',
    code: 'LU',
  },
  {
    name: 'Latvia',
    code: 'LV',
  },
  {
    name: 'Libya',
    code: 'LY',
  },
  {
    name: 'Morocco',
    code: 'MA',
  },
  {
    name: 'Monaco',
    code: 'MC',
  },
  {
    name: 'Moldova',
    code: 'MD',
  },
  {
    name: 'Montenegro',
    code: 'ME',
  },
  {
    name: 'St. Martin',
    code: 'MF',
  },
  {
    name: 'Madagascar',
    code: 'MG',
  },
  {
    name: 'Marshall Islands',
    code: 'MH',
  },
  {
    name: 'North Macedonia',
    code: 'MK',
  },
  {
    name: 'Mali',
    code: 'ML',
  },
  {
    name: 'Myanmar (Burma)',
    code: 'MM',
  },
  {
    name: 'Mongolia',
    code: 'MN',
  },
  {
    name: 'Macao SAR China',
    code: 'MO',
  },
  {
    name: 'Northern Mariana Islands',
    code: 'MP',
  },
  {
    name: 'Martinique',
    code: 'MQ',
  },
  {
    name: 'Mauritania',
    code: 'MR',
  },
  {
    name: 'Montserrat',
    code: 'MS',
  },
  {
    name: 'Malta',
    code: 'MT',
  },
  {
    name: 'Mauritius',
    code: 'MU',
  },
  {
    name: 'Maldives',
    code: 'MV',
  },
  {
    name: 'Malawi',
    code: 'MW',
  },
  {
    name: 'Mexico',
    code: 'MX',
  },
  {
    name: 'Malaysia',
    code: 'MY',
  },
  {
    name: 'Mozambique',
    code: 'MZ',
  },
  {
    name: 'Namibia',
    code: 'NA',
  },
  {
    name: 'New Caledonia',
    code: 'NC',
  },
  {
    name: 'Niger',
    code: 'NE',
  },
  {
    name: 'Norfolk Island',
    code: 'NF',
  },
  {
    name: 'Nigeria',
    code: 'NG',
  },
  {
    name: 'Nicaragua',
    code: 'NI',
  },
  {
    name: 'Netherlands',
    code: 'NL',
  },
  {
    name: 'Norway',
    code: 'NO',
  },
  {
    name: 'Nepal',
    code: 'NP',
  },
  {
    name: 'Nauru',
    code: 'NR',
  },
  {
    name: 'Niue',
    code: 'NU',
  },
  {
    name: 'New Zealand',
    code: 'NZ',
  },
  {
    name: 'Oman',
    code: 'OM',
  },
  {
    name: 'Panama',
    code: 'PA',
  },
  {
    name: 'Peru',
    code: 'PE',
  },
  {
    name: 'French Polynesia',
    code: 'PF',
  },
  {
    name: 'Papua New Guinea',
    code: 'PG',
  },
  {
    name: 'Philippines',
    code: 'PH',
  },
  {
    name: 'Pakistan',
    code: 'PK',
  },
  {
    name: 'Poland',
    code: 'PL',
  },
  {
    name: 'St. Pierre & Miquelon',
    code: 'PM',
  },
  {
    name: 'Pitcairn Islands',
    code: 'PN',
  },
  {
    name: 'Puerto Rico',
    code: 'PR',
  },
  {
    name: 'Palestinian Territories',
    code: 'PS',
  },
  {
    name: 'Portugal',
    code: 'PT',
  },
  {
    name: 'Palau',
    code: 'PW',
  },
  {
    name: 'Paraguay',
    code: 'PY',
  },
  {
    name: 'Qatar',
    code: 'QA',
  },
  {
    name: 'Réunion',
    code: 'RE',
  },
  {
    name: 'Romania',
    code: 'RO',
  },
  {
    name: 'Serbia',
    code: 'RS',
  },
  {
    name: 'Russia',
    code: 'RU',
  },
  {
    name: 'Rwanda',
    code: 'RW',
  },
  {
    name: 'Saudi Arabia',
    code: 'SA',
  },
  {
    name: 'Solomon Islands',
    code: 'SB',
  },
  {
    name: 'Seychelles',
    code: 'SC',
  },
  {
    name: 'Sudan',
    code: 'SD',
  },
  {
    name: 'Sweden',
    code: 'SE',
  },
  {
    name: 'Singapore',
    code: 'SG',
  },
  {
    name: 'St. Helena',
    code: 'SH',
  },
  {
    name: 'Slovenia',
    code: 'SI',
  },
  {
    name: 'Svalbard & Jan Mayen',
    code: 'SJ',
  },
  {
    name: 'Slovakia',
    code: 'SK',
  },
  {
    name: 'Sierra Leone',
    code: 'SL',
  },
  {
    name: 'San Marino',
    code: 'SM',
  },
  {
    name: 'Senegal',
    code: 'SN',
  },
  {
    name: 'Somalia',
    code: 'SO',
  },
  {
    name: 'Suriname',
    code: 'SR',
  },
  {
    name: 'South Sudan',
    code: 'SS',
  },
  {
    name: 'São Tomé & Príncipe',
    code: 'ST',
  },
  {
    name: 'El Salvador',
    code: 'SV',
  },
  {
    name: 'Sint Maarten',
    code: 'SX',
  },
  {
    name: 'Syria',
    code: 'SY',
  },
  {
    name: 'Eswatini',
    code: 'SZ',
  },
  {
    name: 'Turks & Caicos Islands',
    code: 'TC',
  },
  {
    name: 'Chad',
    code: 'TD',
  },
  {
    name: 'French Southern Territories',
    code: 'TF',
  },
  {
    name: 'Togo',
    code: 'TG',
  },
  {
    name: 'Thailand',
    code: 'TH',
  },
  {
    name: 'Tajikistan',
    code: 'TJ',
  },
  {
    name: 'Tokelau',
    code: 'TK',
  },
  {
    name: 'Timor-Leste',
    code: 'TL',
  },
  {
    name: 'Turkmenistan',
    code: 'TM',
  },
  {
    name: 'Tunisia',
    code: 'TN',
  },
  {
    name: 'Tonga',
    code: 'TO',
  },
  {
    name: 'Turkey',
    code: 'TR',
  },
  {
    name: 'Trinidad & Tobago',
    code: 'TT',
  },
  {
    name: 'Tuvalu',
    code: 'TV',
  },
  {
    name: 'Taiwan',
    code: 'TW',
  },
  {
    name: 'Tanzania',
    code: 'TZ',
  },
  {
    name: 'Ukraine',
    code: 'UA',
  },
  {
    name: 'Uganda',
    code: 'UG',
  },
  {
    name: 'U.S. Outlying Islands',
    code: 'UM',
  },
  {
    name: 'United States',
    code: 'US',
  },
  {
    name: 'Uruguay',
    code: 'UY',
  },
  {
    name: 'Uzbekistan',
    code: 'UZ',
  },
  {
    name: 'Vatican City',
    code: 'VA',
  },
  {
    name: 'St. Vincent & Grenadines',
    code: 'VC',
  },
  {
    name: 'Venezuela',
    code: 'VE',
  },
  {
    name: 'British Virgin Islands',
    code: 'VG',
  },
  {
    name: 'U.S. Virgin Islands',
    code: 'VI',
  },
  {
    name: 'Vietnam',
    code: 'VN',
  },
  {
    name: 'Vanuatu',
    code: 'VU',
  },
  {
    name: 'Wallis & Futuna',
    code: 'WF',
  },
  {
    name: 'Samoa',
    code: 'WS',
  },
  {
    name: 'Yemen',
    code: 'YE',
  },
  {
    name: 'Mayotte',
    code: 'YT',
  },
  {
    name: 'South Africa',
    code: 'ZA',
  },
  {
    name: 'Zambia',
    code: 'ZM',
  },
  {
    name: 'Zimbabwe',
    code: 'ZW',
  },
];

export const SecurityConst = {
  authStorage: 'auth-storage',
};

//* For React-query
export const queryKeys = {
  getBlacklistContacts: 'getBlacklistContacts',
  getSuspend10DLCList: 'getSuspend10DLCList',
};

export const sendMethodEnum = {
  oneWay: 1,
  twoWays: 2,
};

export const simPoolStatusEnum = {
  SCANNED: 'SCANNED',
  ACTIVATED: 'ACTIVATED',
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
  BURNED: 'BURNED',
  EXPIRED: 'EXPIRED',
  DELIVERING: 'DELIVERING',
  NOT_DELIVERING: 'NOT_DELIVERING',
};

export const simPoolGroupByEnum = {
  mnoCarrier: 'mnoCarrier',
  country: 'country',
  zipCode: 'zipCode',
};

export const simDetailType = {
  'SINGLE-SIM-STATUS-STATS': 'SINGLE-SIM-STATUS-STATS',
  'SINGLE-SIM-SEND-STATS': 'SINGLE-SIM-SEND-STATS',
  'ALL-SIM-STATUS-STATS': 'ALL-SIM-STATUS-STATS',
  'ALL-SIM-SEND-STATS': 'ALL-SIM-SEND-STATS',
};

export const timeEnum = (start, end, step) => {
  const time = {};
  for (let i = start; i <= end; i += step) {
    time[i] = +i;
  }
  return time;
};

export const timeIntervalEnum = {
  '5 minutes': '5 minutes',
  '10 minutes': '10 minutes',
  '15 minutes': '15 minutes',
  '20 minutes': '20 minutes',
  '30 minutes': '30 minutes',
  '1 hour': '1 hour',
  '2 hours': '2 hours',
  '3 hours': '3 hours',
  '4 hours': '4 hours',
  '6 hours': '6 hours',
  '8 hours': '8 hours',
  '12 hours': '12 hours',
};

export const modemStatus = [
  {
    label: 'All',
    value: '',
  },
  {
    label: 'Online',
    value: 'ONLINE',
  },
  {
    label: 'Offline',
    value: 'OFFLINE',
  },
];

export const modemStatusEnum = {
  0: (
    <div className='alert-dark' style={{ padding: '5px 8px', borderRadius: '5px' }}>
      <b>
        <span role='img' aria-label='no sim car'>
          ⚪
        </span>{' '}
        No SIM card
      </b>
    </div>
  ),
  1: (
    <div className='alert-dark' style={{ padding: '5px 8px', borderRadius: '5px' }}>
      <b>
        <span role='img' aria-label='exist idel sim card'>
          🟠
        </span>{' '}
        Exist idel SIM card
      </b>
    </div>
  ),
  2: (
    <div className='alert-success' style={{ padding: '5px 8px', borderRadius: '5px' }}>
      <b>
        <span role='img' aria-label='registering'>
          🟩
        </span>{' '}
        Registering
      </b>
    </div>
  ),
  3: (
    <div className='alert-success' style={{ padding: '5px 8px', borderRadius: '5px' }}>
      <b>
        <span role='img' aria-label='registered'>
          🟢
        </span>{' '}
        Registered
      </b>
    </div>
  ),
  4: (
    <div className='alert-success' style={{ padding: '5px 8px', borderRadius: '5px' }}>
      <b>
        <span role='img' aria-label='call connected'>
          🟢
        </span>{' '}
        Call connected
      </b>
    </div>
  ),
  5: (
    <div className='alert-warning' style={{ padding: '5px 8px', borderRadius: '5px' }}>
      <b>
        <span role='img' aria-label='no balance or alarm'>
          🟡
        </span>{' '}
        No balance or alarm
      </b>
    </div>
  ),
  6: (
    <div className='alert-danger' style={{ padding: '5px 8px', borderRadius: '5px' }}>
      <b>
        <span role='img' aria-label='register failed'>
          🔴
        </span>{' '}
        Register failed
      </b>
    </div>
  ),
  7: (
    <div className='alert-danger' style={{ padding: '5px 8px', borderRadius: '5px' }}>
      <b>
        <span role='img' aria-label='sim card locked by device'>
          📵
        </span>{' '}
        SIM card locked by device
      </b>
    </div>
  ),
  8: (
    <div className='alert-danger' style={{ padding: '5px 8px', borderRadius: '5px' }}>
      <b>
        <span role='img' aria-label='sim card locked by operator'>
          ⛔
        </span>{' '}
        SIM card locked by operator
      </b>
    </div>
  ),
  9: (
    <div className='alert-danger' style={{ padding: '5px 8px', borderRadius: '5px' }}>
      <b>
        <span role='img' aria-label='recognize sim card error'>
          ❗
        </span>{' '}
        Recognize SIM card error
      </b>
    </div>
  ),
  10: (
    <div className='alert-info' style={{ padding: '5px 8px', borderRadius: '5px' }}>
      <b>
        <span role='img' aria-label='card detected'>
          🔘
        </span>{' '}
        Card Detected
      </b>
    </div>
  ),
  11: (
    <div className='alert-danger' style={{ padding: '5px 8px', borderRadius: '5px' }}>
      <b>
        <span role='img' aria-label='user locked'>
          🚫
        </span>{' '}
        User locked
      </b>
    </div>
  ),
  12: (
    <div className='alert-info' style={{ padding: '5px 8px', borderRadius: '5px' }}>
      <b>
        <span role='img' aria-label='port inter-calling'>
          🔁
        </span>{' '}
        Port inter-calling
      </b>
    </div>
  ),
  13: (
    <div className='alert-info' style={{ padding: '5px 8px', borderRadius: '5px' }}>
      <b>
        <span role='img' aria-label='inter-calling holding'>
          🔵
        </span>{' '}
        Inter-calling holding
      </b>
    </div>
  ),
};

export const modemStatusValue = {
  0: 'No SIM card',
  1: 'Exist idel SIM card',
  2: 'Registering',
  3: 'Registered',
  4: 'Call connected',
  5: 'No balance or alarm',
  6: 'Register failed',
  7: 'SIM card locked by device',
  8: 'SIM card locked by operator',
  9: 'Recognize SIM card error',
  10: 'Card Detected',
  11: 'User locked',
  12: 'Port inter-calling',
  13: 'Inter-calling holding',
};

export const trafficSearchByOptions = [
  {
    label: 'IP address',
    value: 'ipAddress',
  },
  {
    label: 'Clean',
    value: 'clean',
  },
  {
    label: 'Hacker',
    value: 'hacker',
  },
  {
    label: 'Anonymous',
    value: 'anonym',
  },
  {
    label: 'Unknown',
    value: 'unknown',
  },
  {
    label: 'IP address score',
    value: 'score',
  },
];

export const DialogDetailSequenceType = {
  CLONE: 'CLONE',
  EDIT: 'EDIT',
  CREATE: 'CREATE',
};

export const AttachmentExtensionOptions = [
  {
    label: 'Image/jpeg',
    value: 'image/jpeg',
  },
  {
    label: 'Image/png',
    value: 'image/png',
  },
  {
    label: 'Image/gif',
    value: 'image/gif',
  },
  {
    label: 'Image/jpg',
    value: 'image/jpg',
  },
  {
    label: 'Audio/mp3',
    value: 'audio/mpeg',
  },
  {
    label: 'Audio/wav',
    value: 'audio/wav',
  },
  {
    label: 'Audio/x-wav',
    value: 'audio/x-wav',
  },
  {
    label: 'Audio/wave',
    value: 'audio/wave',
  },
  {
    label: 'Audio/x-pn-wav',
    value: 'audio/x-pn-wav',
  },
];

export const MediaTypeOptions = ['jpg', 'txt', 'png', 'mp3', 'gif', 'wav'];

export const allAudioType = [
  'audio/wav',
  'audio/mpeg',
  'audio/aac',
  'audio/aacp',
  'audio/ogg',
  'audio/webm',
  'audio/x-caf',
  'audio/flac',
];

export const errorListOptions = {
  DELIVERED: 0,
  ATTEMPT_FAILED: 1,
  FAILED: 2,
  BLOCKED: 3,
  OPTED_OUT: 4,
  SEND_TO_SELF: 5,
  INVALID_MESSAGE: 6,
  DID_NOT_WORKING: 7,
  REJECTED_BY_VENDOR: 8,
  REJECTED_BY_EXCEED_QUOTA: 9,
  INVALID_DESTINATION: 10,
  EXPIRED: 11,
  BLOCKED_BY_SPAM: 12,
};

export const listFilterInbox = [
  {
    id: 2,
    label: 'Needs Response',
    value: 'filterResponse',
  },
  {
    id: 3,
    label: 'Unread',
    value: 'filterUnread',
  },
  {
    id: 4,
    label: 'Received',
    value: 'filterReceived',
  },
  {
    id: 5,
    label: 'Read',
    value: 'filterRead',
  },
  {
    id: 6,
    label: 'Sent',
    value: 'filterSent',
  },
  {
    id: 8,
    label: 'Error',
    value: 'filterError',
  },
  {
    id: 9,
    label: 'Send API',
    value: -2,
    isCpIds: true,
  },
  {
    id: 10,
    label: 'Responder',
    value: -3,
    isCpIds: true,
  },
  {
    id: 7,
    label: 'Starred',
    value: 'filterStarred',
  },
];

export const statusOptions = [
  {
    label: 'Unread',
    value: 'filterUnread',
  },
  {
    label: 'Read',
    value: 'filterRead',
  },
  {
    label: 'Received',
    value: 'filterReceived',
  },
  {
    label: 'Sent',
    value: 'filterSent',
  },
  {
    label: 'Delivered',
    value: 'filterDelivered',
  },
  {
    label: 'Forwarded call',
    value: 'filterForwarded',
  },
];

export const positionEnum = {
  left: 'left',
  right: 'right',
  top: 'top',
  bottom: 'bottom',
};

export const suggestByHeader = {
  ipMaxClick: ['10', '100', '1000'],
  ipRange: ['ipA:ipA1,ipB:ipB1,...', '192.168.0.1:192.168.0.99,127.0.0.11:127.0.0.250'],
  ip: ['192.168.1.1'],
  Useragent: [
    'Apache-HttpClient/UNAVAILABLE (java 1.4)',
    'Apache-HttpClient/4.5.5 (Java/1.8.0_152)',
    'Mozilla/4.0 (compatible; MSIE 7.0; Windows NT 6.1; WOW64; Trident/7.0; SLCC2; .NET CLR 2.0.50727; .NET CLR 3.5.30729; .NET CLR 3.0.30729; .NET4.0C; .NET4.0E)',
    'Mozilla/4.0 (compatible; MSIE 7.0; Windows NT 6.2; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; .NET CLR 2.0.50727; .NET CLR 3.0.30729; .NET CLR 3.5.30729)',
    'Mozilla/4.0 (compatible; MSIE 7.0; Windows NT 6.2; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Tablet PC 2.0; .NET CLR 2.0.50727; .NET CLR 3.0.30729; .NET CLR 3.5.30729)',
    'Mozilla/4.0 (compatible; MSIE 4.0; Windows NT 5.2; Trident/7.0; SLCC2; .NET CLR 3.5.30729; .NET CLR 3.0.30729; .NET4.0C; .NET4.0E; .NET CLR 1.1.4322; .NET CLR 2.0.50727)',
    'Mozilla/4.0 (compatible; MSIE 7.0; Windows NT 6.1; WOW64; Trident/7.0; SLCC2; Media Center PC 6.0; .NET CLR 3.5.30729; .NET CLR 3.0.30729; .NET CLR 2.0.50727; .NET4.0C; .NET4.0E)',
    'Apache-HttpClient/4.5.6 (Java/1.8.0_111)',
    'Mozilla/4.0 (compatible; MSIE 8.0; Windows NT 5.1; Trident/4.0)',
    'Message+/2.5.0 CFNetwork/902.3.1 Darwin/17.7.0 (x86_64)',
    'Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:62.0) Gecko/20100101 Firefox/62.0',
    'Apache-HttpAsyncClient/4.1.4 (Java/1.8.0_181)',
    'Mozilla/5.0 (Windows NT 6.1; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/31.0.1650.57 Safari/537.36',
    'CakePHP',
    'Mozilla/5.0 (Windows NT 6.3; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/54.0.2840.71 Safari/537.36',
    'Mozilla/5.0 (compatible; SimpleScraper)',
    'Mozilla/5.0 (Windows NT 6.1; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/54.0.2840.99 Safari/537.36',
    'Mozilla/5.0 (Windows NT 6.1; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/41.0.2272.89 Safari/537.36',
    'Mozilla/5.0 (Windows NT 6.3; Win64; x64; rv:63.0) Gecko/20100101 Firefox/63.0',
    'Mozilla/5.0 (X11; Linux i686; rv:49.0) Gecko/20100101 Firefox/49.0',
    'Mozilla/5.0 (X11; Ubuntu; Linux i686; rv:24.0) Gecko/20100101 Firefox/24.0',
    'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_11_1) AppleWebKit/601.2.4 (KHTML, like Gecko) Version/9.0.1 Safari/601.2.4 facebookexternalhit/1.1 Facebot Twitterbot/1.0',
  ],
  DeviceClass: ['Robot', 'Desktop', 'Tablet', 'Mobile', 'Unknown', 'Hacker'],
  DeviceName: [
    'Apache HttpClient',
    'Desktop',
    'Tablet PC',
    'Apple iOS Device',
    'Linux Desktop',
    'Apache HttpAsyncClient',
    'Hacker',
    'Unknown',
    'Facebook Facebot Twitterbot',
  ],
  PhoneBrand: ['Apache', 'Unknown', 'Apple', 'Hacker', 'Facebook'],
  OperatingSystemClass: ['Unknown', 'Desktop', 'Mobile', 'Hacker', 'Cloud'],
  OperatingSystemName: [
    'Unknown',
    'Windows NT',
    'Darwin (iOS)',
    'Ubuntu',
    'Hacker',
    'Linux',
    'Cloud',
  ],
  OperatingSystemVersion: [
    '??',
    '7',
    '8',
    'XP x64 Edition',
    'XP',
    '17.7.0',
    'Hacker',
    '8.1',
    'Intel i686',
  ],
  OperatingSystemVersionMajor: [
    '??',
    '7',
    '8',
    'XP x64 Edition',
    'XP',
    '17',
    'Hacker',
    'Intel i686',
  ],
  OS: [
    'Unknown ??',
    'Windows 7',
    'Windows 8',
    'Windows XP x64 Edition',
    'Windows XP',
    'Darwin (iOS) 17.7.0',
    'Ubuntu ??',
    'Hacker',
    'Windows 8.1',
    'Linux Intel i686',
    'Cloud ??',
  ],
  OperatingSystemNameVersionMajor: [
    'Unknown ??',
    'Windows 7',
    'Windows 8',
    'Windows XP x64 Edition',
    'Windows XP',
    'Darwin (iOS) 17',
    'Ubuntu ??',
    'Hacker',
    'Linux Intel i686',
    'Cloud ??',
  ],
  LayoutEngineClass: ['Unknown', 'Browser', 'Mobile App', 'Hacker', 'Robot'],
  LayoutEngineName: [
    'Unknown',
    'Trident',
    'Message',
    'Gecko',
    'Blink',
    'Hacker',
    'Mozilla',
    'Facebot Twitterbot',
  ],
  LayoutEngineVersion: [
    '??',
    '7.0',
    '4.0',
    '2.5.0',
    '62.0',
    '31.0',
    'Hacker',
    '54.0',
    '5.0',
    '41.0',
    '63.0',
    '49.0',
    '24.0',
    '1.0',
  ],
  LayoutEngineVersionMajor: [
    '??',
    '7',
    '4',
    '2',
    '62',
    '31',
    'Hacker',
    '54',
    '5',
    '41',
    '63',
    '49',
    '24',
    '1',
  ],
  LayoutEngineNameVersion: [
    'Unknown ??',
    'Trident 7.0',
    'Trident 4.0',
    'Message 2.5.0',
    'Gecko 62.0',
    'Blink 31.0',
    'Hacker',
    'Blink 54.0',
    'Mozilla 5.0',
    'Blink 41.0',
    'Gecko 63.0',
    'Gecko 49.0',
    'Gecko 24.0',
    'Facebot Twitterbot 1.0',
  ],
  LayoutEngineNameVersionMajor: [
    'Unknown ??',
    'Trident 7',
    'Trident 4',
    'Message 2',
    'Gecko 62',
    'Blink 31',
    'Hacker',
    'Blink 54',
    'Mozilla 5',
    'Blink 41',
    'Gecko 63',
    'Gecko 49',
    'Gecko 24',
    'Facebot Twitterbot 1',
  ],
  AgentClass: ['Special', 'Browser', 'Mobile App', 'Hacker', 'Robot'],
  AgentName: [
    'Apache-HttpClient',
    'Internet Explorer',
    'Message',
    'Firefox',
    'Apache-HttpAsyncClient',
    'Chrome',
    'Hacker',
    'Netscape',
    'Facebot Twitterbot',
  ],
  AgentVersion: [
    'UNAVAILABLE',
    '4.5.5',
    '11.0',
    '4.5.6',
    '8.0',
    '2.5.0',
    '62.0',
    '4.1.4',
    '31.0.1650.57',
    'Hacker',
    '54.0.2840.71',
    '5.0',
    '54.0.2840.99',
    '41.0.2272.89',
    '63.0',
    '49.0',
    '24.0',
    '1.0',
  ],
  AgentVersionMajor: [
    'UNAVAILABLE',
    '4',
    '11',
    '8',
    '2',
    '62',
    '31',
    'Hacker',
    '54',
    '5',
    '41',
    '63',
    '49',
    '24',
    '1',
  ],
  WebBrowser: [
    'Apache-HttpClient UNAVAILABLE',
    'Apache-HttpClient 4.5.5',
    'Internet Explorer 11.0',
    'Apache-HttpClient 4.5.6',
    'Internet Explorer 8.0',
    'Message 2.5.0',
    'Firefox 62.0',
    'Apache-HttpAsyncClient 4.1.4',
    'Chrome 31.0.1650.57',
    'Hacker',
    'Chrome 54.0.2840.71',
    'Netscape 5.0',
    'Chrome 54.0.2840.99',
    'Chrome 41.0.2272.89',
    'Firefox 63.0',
    'Firefox 49.0',
    'Firefox 24.0',
    'Facebot Twitterbot 1.0',
  ],
  AgentNameVersionMajor: [
    'Apache-HttpClient UNAVAILABLE',
    'Apache-HttpClient 4',
    'Internet Explorer 11',
    'Internet Explorer 8',
    'Message 2',
    'Firefox 62',
    'Apache-HttpAsyncClient 4',
    'Chrome 31',
    'Hacker',
    'Chrome 54',
    'Netscape 5',
    'Chrome 41',
    'Firefox 63',
    'Firefox 49',
    'Firefox 24',
    'Facebot Twitterbot 1',
  ],
  DeviceCpu: ['Intel x86_64', 'Intel i686'],
  DeviceCpuBits: ['64', '32'],
  IECompatibilityVersion: ['7.0'],
  IECompatibilityVersionMajor: ['7'],
  IECompatibilityNameVersion: ['Internet Explorer 7.0'],
  IECompatibilityNameVersionMajor: ['Internet Explorer 7'],
  LayoutEngineBuild: ['20100101'],
  DeviceVersion: ['Hacker'],
};

export const errorTypeIds = {
  ATTEMPT_FAILED: 1,
  BLOCKED: 3,
  FAILED: 2,
  FAILED_FORWARD: 13,
  NO_RESPONDER_AVAILABLE: 14,
};
